const fallbackWidth = '24';
const fallbackHeight = '24';
export default function useIcons() {
  const CameraIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const UserIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
          fill="currentColor"
        />
        <path
          d="M17.08 14.15C14.29 12.29 9.73999 12.29 6.92999 14.15C5.65999 15 4.95999 16.15 4.95999 17.38C4.95999 18.61 5.65999 19.75 6.91999 20.59C8.31999 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z"
          fill="currentColor"
        />
      </svg>
    );
  };

  const UserLineIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const DashboardIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 10V2.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.4952 6.25L3.50482 13.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const GroupIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 25 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M9.00146 2C6.38146 2 4.25146 4.13 4.25146 6.75C4.25146 9.32 6.26147 11.4 8.88146 11.49C8.96146 11.48 9.04147 11.48 9.10147 11.49C9.12147 11.49 9.13146 11.49 9.15146 11.49C9.16146 11.49 9.16146 11.49 9.17146 11.49C11.7315 11.4 13.7415 9.32 13.7515 6.75C13.7515 4.13 11.6215 2 9.00146 2Z"
          fill="currentColor"
        />
        <path
          d="M14.0815 14.15C11.2915 12.29 6.74149 12.29 3.93149 14.15C2.66149 15 1.96149 16.15 1.96149 17.38C1.96149 18.61 2.66149 19.75 3.92149 20.59C5.32149 21.53 7.16149 22 9.00149 22C10.8415 22 12.6815 21.53 14.0815 20.59C15.3415 19.74 16.0415 18.6 16.0415 17.36C16.0315 16.13 15.3415 14.99 14.0815 14.15Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M19.9915 7.33998C20.1515 9.27998 18.7715 10.98 16.8615 11.21C16.8515 11.21 16.8515 11.21 16.8415 11.21H16.8115C16.7515 11.21 16.6914 11.21 16.6414 11.23C15.6714 11.28 14.7815 10.97 14.1115 10.4C15.1415 9.47998 15.7315 8.09998 15.6115 6.59998C15.5415 5.78998 15.2615 5.04998 14.8415 4.41998C15.2215 4.22998 15.6615 4.10998 16.1115 4.06998C18.0715 3.89998 19.8215 5.35998 19.9915 7.33998Z"
          fill="currentColor"
        />
        <path
          d="M21.9915 16.59C21.9115 17.56 21.2915 18.4 20.2515 18.97C19.2515 19.52 17.9915 19.78 16.7415 19.75C17.4615 19.1 17.8815 18.29 17.9615 17.43C18.0615 16.19 17.4715 15 16.2915 14.05C15.6215 13.52 14.8415 13.1 13.9915 12.79C16.2015 12.15 18.9815 12.58 20.6915 13.96C21.6115 14.7 22.0815 15.63 21.9915 16.59Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const ListIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 3.5H5.49999C5.18999 3.5 4.88999 3.65 4.69999 3.9L3.19999 5.9C2.70999 6.56 3.17999 7.5 3.99999 7.5H18.5C18.81 7.5 19.11 7.35 19.3 7.1L20.8 5.1C21.29 4.44 20.82 3.5 20 3.5Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M3.99999 10H18.5C18.81 10 19.11 10.15 19.3 10.4L20.8 12.4C21.29 13.06 20.82 14 20 14H5.49999C5.18999 14 4.88999 13.85 4.69999 13.6L3.19999 11.6C2.70999 10.94 3.17999 10 3.99999 10Z"
          fill="currentColor"
        />
        <path
          d="M20 16.5H5.49999C5.18999 16.5 4.88999 16.65 4.69999 16.9L3.19999 18.9C2.70999 19.56 3.17999 20.5 3.99999 20.5H18.5C18.81 20.5 19.11 20.35 19.3 20.1L20.8 18.1C21.29 17.44 20.82 16.5 20 16.5Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CallIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M11.79 14.21L8.52 17.48C8.16 17.16 7.81 16.83 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.09 13.57 11.44 13.91 11.79 14.21Z"
          fill="currentColor"
        />
        <path
          d="M21.9701 18.33C21.9701 18.61 21.9201 18.9 21.8201 19.18C21.7901 19.26 21.7601 19.34 21.7201 19.42C21.5501 19.78 21.3301 20.12 21.0401 20.44C20.5501 20.98 20.0101 21.37 19.4001 21.62C19.3901 21.62 19.3801 21.63 19.3701 21.63C18.7801 21.87 18.1401 22 17.4501 22C16.4301 22 15.3401 21.76 14.1901 21.27C13.0401 20.78 11.8901 20.12 10.7501 19.29C10.3601 19 9.9701 18.71 9.6001 18.4L12.8701 15.13C13.1501 15.34 13.4001 15.5 13.6101 15.61C13.6601 15.63 13.7201 15.66 13.7901 15.69C13.8701 15.72 13.9501 15.73 14.0401 15.73C14.2101 15.73 14.3401 15.67 14.4501 15.56L15.2101 14.81C15.4601 14.56 15.7001 14.37 15.9301 14.25C16.1601 14.11 16.3901 14.04 16.6401 14.04C16.8301 14.04 17.0301 14.08 17.2501 14.17C17.4701 14.26 17.7001 14.39 17.9501 14.56L21.2601 16.91C21.5201 17.09 21.7001 17.3 21.8101 17.55C21.9101 17.8 21.9701 18.05 21.9701 18.33Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CallRecordIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.4" cx="12" cy="12" r="10" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7.75C9.65279 7.75 7.75 9.65279 7.75 12C7.75 14.3472 9.65279 16.25 12 16.25C14.3472 16.25 16.25 14.3472 16.25 12C16.25 9.65279 14.3472 7.75 12 7.75ZM6.25 12C6.25 8.82436 8.82436 6.25 12 6.25C15.1756 6.25 17.75 8.82436 17.75 12C17.75 15.1756 15.1756 17.75 12 17.75C8.82436 17.75 6.25 15.1756 6.25 12Z"
          fill="currentColor"
        />
        <circle cx="12" cy="12" r="1" fill="currentColor" />
      </svg>
    );
  };
  const ChangeStatusIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.7002 9.26001L12.0002 12.33L17.2602 9.28001"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 17.7701V12.3201"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.7603 6.2901L7.56024 8.0701C6.84024 8.4701 6.24023 9.4801 6.24023 10.3101V13.7001C6.24023 14.5301 6.83024 15.5401 7.56024 15.9401L10.7603 17.7201C11.4403 18.1001 12.5602 18.1001 13.2502 17.7201L16.4503 15.9401C17.1703 15.5401 17.7702 14.5301 17.7702 13.7001V10.3001C17.7702 9.4701 17.1803 8.4601 16.4503 8.0601L13.2502 6.2801C12.5602 5.9001 11.4403 5.9001 10.7603 6.2901Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M2 9C2 5.13 5.13 2 9 2L7.95001 3.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const VoicemailIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 15.5C15 19.09 12.09 22 8.5 22C4.91 22 2 19.09 2 15.5C2 11.91 4.91 9 8.5 9C8.67 9 8.84999 9.01 9.01999 9.02C12.19 9.27 14.73 11.81 14.98 14.98C14.99 15.15 15 15.33 15 15.5Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M22 8.5C22 12.09 19.09 15 15.5 15C15.33 15 15.15 14.99 14.98 14.98C14.73 11.81 12.19 9.27 9.01999 9.02C9.00999 8.85 9 8.67 9 8.5C9 4.91 11.91 2 15.5 2C19.09 2 22 4.91 22 8.5Z"
          fill="currentColor"
        />
        <path
          d="M5.59 2H3C2.45 2 2 2.45 2 3V5.59C2 6.48 3.07999 6.93 3.70999 6.3L6.29999 3.71001C6.91999 3.08001 6.48 2 5.59 2Z"
          fill="currentColor"
        />
        <path
          d="M18.41 22H21C21.55 22 22 21.55 22 21V18.41C22 17.52 20.92 17.07 20.29 17.7L17.7 20.29C17.08 20.92 17.52 22 18.41 22Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CallHistoryIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7.27148C12.4142 7.27148 12.75 7.60727 12.75 8.02148V12.4809L15.2372 13.31C15.6301 13.441 15.8425 13.8657 15.7115 14.2587C15.5805 14.6516 15.1558 14.864 14.7628 14.733L11.7628 13.733C11.4566 13.6309 11.25 13.3443 11.25 13.0215V8.02148C11.25 7.60727 11.5858 7.27148 12 7.27148Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const ProfileIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 25 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12.0015 2C9.38146 2 7.25146 4.13 7.25146 6.75C7.25146 9.32 9.26147 11.4 11.8815 11.49C11.9615 11.48 12.0415 11.48 12.1015 11.49C12.1215 11.49 12.1315 11.49 12.1515 11.49C12.1615 11.49 12.1615 11.49 12.1715 11.49C14.7315 11.4 16.7415 9.32 16.7515 6.75C16.7515 4.13 14.6215 2 12.0015 2Z"
          fill="currentColor"
        />
        <path
          d="M17.0814 14.1499C14.2914 12.2899 9.74143 12.2899 6.93143 14.1499C5.66143 14.9999 4.96143 16.1499 4.96143 17.3799C4.96143 18.6099 5.66143 19.7499 6.92143 20.5899C8.32143 21.5299 10.1614 21.9999 12.0014 21.9999C13.8414 21.9999 15.6814 21.5299 17.0814 20.5899C18.3414 19.7399 19.0414 18.5999 19.0414 17.3599C19.0314 16.1299 18.3414 14.9899 17.0814 14.1499Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const LogoutIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6V8H16C16.2563 8 16.5071 8.02411 16.75 8.0702V6C16.75 3.37665 14.6234 1.25 12 1.25C9.37665 1.25 7.25 3.37665 7.25 6V8.0702C7.49294 8.02411 7.74365 8 8 8H8.75V6Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M4 12C4 9.79086 5.79086 8 8 8H16C18.2091 8 20 9.79086 20 12V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V12Z"
          fill="currentColor"
        />
        <circle cx="12" cy="15" r="2" fill="currentColor" />
      </svg>
    );
  };
  const MoreVIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 3 13"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 1.25C0 0.559644 0.559644 0 1.25 0C1.94036 0 2.5 0.559644 2.5 1.25C2.5 1.94036 1.94036 2.5 1.25 2.5C0.559644 2.5 0 1.94036 0 1.25ZM0 6.25C0 5.55964 0.559644 5 1.25 5C1.94036 5 2.5 5.55964 2.5 6.25C2.5 6.94036 1.94036 7.5 1.25 7.5C0.559644 7.5 0 6.94036 0 6.25ZM1.25 10C0.559644 10 0 10.5596 0 11.25C0 11.9404 0.559644 12.5 1.25 12.5C1.94036 12.5 2.5 11.9404 2.5 11.25C2.5 10.5596 1.94036 10 1.25 10Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CrossRoundIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2984 15.3588C14.5913 15.6517 15.0662 15.6517 15.3591 15.3588C15.652 15.0659 15.652 14.591 15.3591 14.2982L13.061 12.0001L15.3591 9.70209C15.652 9.4092 15.652 8.93433 15.3591 8.64143C15.0662 8.34854 14.5913 8.34854 14.2984 8.64143L12.0004 10.9395L9.70222 8.6413C9.40933 8.34841 8.93445 8.34841 8.64156 8.6413C8.34867 8.93419 8.34867 9.40907 8.64156 9.70196L10.9397 12.0001L8.64154 14.2983C8.34865 14.5912 8.34865 15.0661 8.64154 15.3589C8.93444 15.6518 9.40931 15.6518 9.70221 15.3589L12.0004 13.0608L14.2984 15.3588Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CrossIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.66683 1.27398L8.72683 0.333984L5.00016 4.06065L1.2735 0.333984L0.333496 1.27398L4.06016 5.00065L0.333496 8.72732L1.2735 9.66732L5.00016 5.94065L8.72683 9.66732L9.66683 8.72732L5.94016 5.00065L9.66683 1.27398Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const RefreshIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.892 5.0799C14.022 4.8199 13.062 4.6499 12.002 4.6499C7.21203 4.6499 3.33203 8.5299 3.33203 13.3199C3.33203 18.1199 7.21203 21.9999 12.002 21.9999C16.792 21.9999 20.672 18.1199 20.672 13.3299C20.672 11.5499 20.132 9.8899 19.212 8.5099"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1322 5.32L13.2422 2"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1317 5.32007L12.7617 7.78007"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const PencilIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 21C10.75 20.5858 11.0858 20.25 11.5 20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H11.5C11.0858 21.75 10.75 21.4142 10.75 21Z"
          fill="currentColor"
        />
        <path
          d="M7.31963 17.9881L10.7523 17.4977C11.2475 17.427 11.7064 17.1976 12.06 16.8439L18.6883 10.2156C18.6883 10.2156 17.0537 10.2156 15.419 8.58102C13.7844 6.94639 13.7844 5.31177 13.7844 5.31177L7.15616 11.94C6.80248 12.2937 6.57305 12.7526 6.50231 13.2477L6.01193 16.6804C5.90295 17.4433 6.5568 18.0971 7.31963 17.9881Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M20.3227 5.31171L18.6881 3.67708C17.7853 2.77431 16.3216 2.77431 15.4188 3.67708L13.7842 5.31171C13.7842 5.31171 13.7842 6.94634 15.4188 8.58096C17.0534 10.2156 18.6881 10.2156 18.6881 10.2156L20.3227 8.58096C21.2255 7.67818 21.2255 6.21449 20.3227 5.31171Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const BellIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.4617 1.00013C4.84629 0.846296 5.28277 1.03336 5.4366 1.41795C5.59044 1.80253 5.40338 2.23901 5.01879 2.39285L4.85156 2.45974C3.54571 2.98208 2.50405 4.00653 1.96002 5.3035L1.88322 5.48659C1.723 5.86857 1.28347 6.04833 0.901495 5.88811C0.519524 5.72789 0.33976 5.28835 0.499981 4.90638L0.576781 4.72329C1.27624 3.05576 2.61553 1.7386 4.29448 1.06702L4.4617 1.00013ZM13.5382 1.04432C13.1536 0.890485 12.7172 1.07755 12.5633 1.46213C12.4095 1.84672 12.5966 2.2832 12.9811 2.43704L13.1484 2.50393C14.4542 3.02627 15.4959 4.05072 16.0399 5.34769L16.1167 5.53078C16.2769 5.91276 16.7165 6.09252 17.0984 5.9323C17.4804 5.77208 17.6602 5.33254 17.5 4.95057L17.4232 4.76748C16.7237 3.09995 15.3844 1.78279 13.7055 1.11121L13.5382 1.04432ZM14.7772 17.0002C16.6055 17.0002 17.6492 15.1611 16.5522 13.8724C16.0665 13.3018 15.7672 12.6251 15.6867 11.9155L15.2395 7.97543C14.9984 5.85088 13.4123 4.10744 11.2699 3.37391V3.27019C11.2699 2.01653 10.2536 1.00024 8.99997 1.00024C7.74631 1.00024 6.73002 2.01653 6.73002 3.27019V3.37391C4.58762 4.10744 3.00156 5.85088 2.76043 7.97543L2.31324 11.9155C2.2327 12.6251 1.93341 13.3018 1.44775 13.8724C0.350725 15.1611 1.3944 17.0002 3.22278 17.0002H14.7772ZM11.9721 19.0718C11.5147 20.1995 10.3565 21.0002 8.99997 21.0002C7.64345 21.0002 6.48525 20.1995 6.02787 19.0718C6.0088 19.0247 5.99997 18.9742 5.99997 18.9235C5.99997 18.6896 6.18957 18.5 6.42346 18.5H11.5765C11.8104 18.5 12 18.6896 12 18.9235C12 18.9742 11.9911 19.0247 11.9721 19.0718Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const BackAngleIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 25 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M16.192 2H7.81195C4.17195 2 2.00195 4.17 2.00195 7.81V16.18C2.00195 19.83 4.17195 22 7.81195 22H16.182C19.822 22 21.992 19.83 21.992 16.19V7.81C22.002 4.17 19.832 2 16.192 2Z"
          fill="currentColor"
        />
        <path
          d="M13.2619 16.2802C13.0719 16.2802 12.8819 16.2102 12.7319 16.0602L9.20188 12.5302C8.91188 12.2402 8.91188 11.7602 9.20188 11.4702L12.7319 7.94016C13.0219 7.65016 13.5019 7.65016 13.7919 7.94016C14.0819 8.23016 14.0819 8.71016 13.7919 9.00016L10.7919 12.0002L13.7919 15.0002C14.0819 15.2902 14.0819 15.7702 13.7919 16.0602C13.6519 16.2102 13.4619 16.2802 13.2619 16.2802Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const BackRoundIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12.002 22C17.5248 22 22.002 17.5228 22.002 12C22.002 6.47715 17.5248 2 12.002 2C6.47911 2 2.00195 6.47715 2.00195 12C2.00195 17.5228 6.47911 22 12.002 22Z"
          fill="currentColor"
        />
        <path
          d="M13.2619 16.2799C13.0719 16.2799 12.8819 16.2099 12.7319 16.0599L9.20188 12.5299C8.91188 12.2399 8.91188 11.7599 9.20188 11.4699L12.7319 7.93991C13.0219 7.64991 13.5019 7.64991 13.7919 7.93991C14.0819 8.22991 14.0819 8.70991 13.7919 8.99991L10.7919 11.9999L13.7919 14.9999C14.0819 15.2899 14.0819 15.7699 13.7919 16.0599C13.6519 16.2099 13.4619 16.2799 13.2619 16.2799Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const WarningOutlineIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="17" r="1" fill="currentColor" />
        <path
          d="M11.9999 8.99997V14M4.32789 21H19.6721C21.4445 21 22.5649 19.1433 21.7041 17.6324L14.032 4.16592C13.1464 2.61136 10.8536 2.61136 9.96798 4.16592L2.29587 17.6324C1.4351 19.1433 2.55546 21 4.32789 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const SuccessOutlineIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.7687 21.7775 9.58934 21.3704 8.5M7 10L10.5264 12.8211C11.3537 13.483 12.5536 13.3848 13.2624 12.5973L21 4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  };
  const InfoOutlineIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="7" r="1" fill="currentColor" />
        <path
          d="M11 10H12V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  //-----newiconsss-------//
  const AppleIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0998 19.16C19.6898 18.26 19.9098 17.8 20.3598 16.79C17.0398 15.53 16.5098 10.8 19.7898 8.99C18.7898 7.73 17.3798 7 16.0498 7C15.0898 7 14.4298 7.25 13.8398 7.48C13.3398 7.67 12.8898 7.84 12.3298 7.84C11.7298 7.84 11.1998 7.65 10.6398 7.45C10.0398 7.23 9.39983 7 8.59983 7C7.10983 7 5.51983 7.91 4.50983 9.47C3.08983 11.67 3.33983 15.79 5.62983 19.31C6.44983 20.57 7.54984 21.98 8.97984 22C9.57984 22.01 9.96983 21.83 10.3998 21.64C10.8898 21.42 11.4198 21.18 12.3498 21.18C13.2798 21.17 13.7998 21.42 14.2898 21.64C14.7098 21.83 15.0898 22.01 15.6798 22C17.1198 21.98 18.2798 20.42 19.0998 19.16Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8399 2C15.9999 3.1 15.5499 4.19 14.9599 4.95C14.3299 5.77 13.2299 6.41 12.1699 6.37C11.9799 5.31 12.4699 4.22 13.0699 3.49C13.7399 2.69 14.8699 2.07 15.8399 2Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const GoogleIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.6258 11.2139C20.6258 10.4225 20.5603 9.84497 20.4185 9.24609H11.1973V12.818H16.6099C16.5008 13.7057 15.9115 15.0425 14.602 15.9408L14.5836 16.0603L17.4992 18.2738L17.7012 18.2936C19.5563 16.6145 20.6258 14.1441 20.6258 11.2139Z"
          fill="#4285F4"
        />
        <path
          d="M11.1967 20.6258C13.8484 20.6258 16.0745 19.7702 17.7006 18.2944L14.6014 15.9415C13.772 16.5083 12.6589 16.904 11.1967 16.904C8.59946 16.904 6.39512 15.225 5.60933 12.9043L5.49415 12.9139L2.4625 15.2132L2.42285 15.3212C4.03791 18.4654 7.35536 20.6258 11.1967 20.6258Z"
          fill="#34CAA5"
        />
        <path
          d="M5.61006 12.9038C5.40272 12.305 5.28273 11.6632 5.28273 11.0002C5.28273 10.3371 5.40272 9.69549 5.59915 9.09661L5.59366 8.96906L2.524 6.63281L2.42357 6.67963C1.75792 7.98437 1.37598 9.44953 1.37598 11.0002C1.37598 12.5509 1.75792 14.016 2.42357 15.3207L5.61006 12.9038Z"
          fill="#FDCF24"
        />
        <path
          d="M11.1967 5.09664C13.0409 5.09664 14.2849 5.87733 14.9943 6.52974L17.7661 3.8775C16.0638 2.32681 13.8485 1.375 11.1967 1.375C7.35539 1.375 4.03792 3.53526 2.42285 6.6794L5.59844 9.09638C6.39514 6.77569 8.59949 5.09664 11.1967 5.09664Z"
          fill="#EB4335"
        />
      </svg>
    );
  };
  const HomeIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const CalendarIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const AgentInfoIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 22V4C6 3.46957 6.21071 2.96086 6.58579 2.58579C6.96086 2.21071 7.46957 2 8 2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V22H6Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 18H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const AgentsIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.4998 9.88771C22.4623 9.88771 22.4373 9.88771 22.3998 9.88771H22.3373C19.9748 9.81271 18.2123 7.9877 18.2123 5.7377C18.2123 3.4377 20.0873 1.5752 22.3748 1.5752C24.6623 1.5752 26.5373 3.4502 26.5373 5.7377C26.5248 8.0002 24.7623 9.8252 22.5123 9.9002C22.5123 9.8877 22.5123 9.88771 22.4998 9.88771ZM22.3748 3.4377C21.1123 3.4377 20.0873 4.4627 20.0873 5.7252C20.0873 6.9627 21.0498 7.96271 22.2873 8.01271C22.2998 8.00021 22.3998 8.00021 22.5123 8.01271C23.7248 7.95021 24.6623 6.9502 24.6748 5.7252C24.6748 4.4627 23.6498 3.4377 22.3748 3.4377Z"
          fill="currentColor"
        />
        <path
          d="M22.5125 19.0998C22.025 19.0998 21.5375 19.0623 21.05 18.9748C20.5375 18.8873 20.2 18.3998 20.2875 17.8873C20.375 17.3748 20.8625 17.0373 21.375 17.1248C22.9125 17.3873 24.5375 17.0998 25.625 16.3748C26.2125 15.9873 26.525 15.4998 26.525 15.0123C26.525 14.5248 26.2 14.0498 25.625 13.6623C24.5375 12.9373 22.8875 12.6498 21.3375 12.9248C20.825 13.0248 20.3375 12.6748 20.25 12.1623C20.1625 11.6498 20.5 11.1623 21.0125 11.0748C23.05 10.7123 25.1625 11.0998 26.6625 12.0998C27.7625 12.8373 28.4 13.8873 28.4 15.0123C28.4 16.1248 27.775 17.1873 26.6625 17.9373C25.525 18.6873 24.05 19.0998 22.5125 19.0998Z"
          fill="currentColor"
        />
        <path
          d="M7.46248 9.8875C7.44998 9.8875 7.43748 9.8875 7.43748 9.8875C5.18748 9.8125 3.42498 7.9875 3.41248 5.7375C3.41248 3.4375 5.28748 1.5625 7.57498 1.5625C9.86248 1.5625 11.7375 3.4375 11.7375 5.725C11.7375 7.9875 9.97498 9.8125 7.72498 9.8875L7.46248 8.95L7.54998 9.8875C7.52498 9.8875 7.48748 9.8875 7.46248 9.8875ZM7.58748 8.0125C7.66248 8.0125 7.72498 8.0125 7.79998 8.025C8.91248 7.975 9.88748 6.975 9.88748 5.7375C9.88748 4.475 8.86248 3.44999 7.59998 3.44999C6.33748 3.44999 5.31248 4.475 5.31248 5.7375C5.31248 6.9625 6.26248 7.95 7.47498 8.025C7.48748 8.0125 7.53748 8.0125 7.58748 8.0125Z"
          fill="currentColor"
        />
        <path
          d="M7.45 19.0998C5.9125 19.0998 4.4375 18.6873 3.3 17.9373C2.2 17.1998 1.5625 16.1373 1.5625 15.0123C1.5625 13.8998 2.2 12.8373 3.3 12.0998C4.8 11.0998 6.9125 10.7123 8.95 11.0748C9.4625 11.1623 9.8 11.6498 9.7125 12.1623C9.625 12.6748 9.1375 13.0248 8.625 12.9248C7.075 12.6498 5.4375 12.9373 4.3375 13.6623C3.75 14.0498 3.4375 14.5248 3.4375 15.0123C3.4375 15.4998 3.7625 15.9873 4.3375 16.3748C5.425 17.0998 7.05 17.3873 8.5875 17.1248C9.1 17.0373 9.5875 17.3873 9.675 17.8873C9.7625 18.3998 9.425 18.8873 8.9125 18.9748C8.425 19.0623 7.9375 19.0998 7.45 19.0998Z"
          fill="currentColor"
        />
        <path
          d="M14.9998 19.2246C14.9623 19.2246 14.9373 19.2246 14.8998 19.2246H14.8373C12.4748 19.1496 10.7123 17.3246 10.7123 15.0746C10.7123 12.7746 12.5873 10.9121 14.8748 10.9121C17.1623 10.9121 19.0373 12.7871 19.0373 15.0746C19.0248 17.3371 17.2623 19.1621 15.0123 19.2371C15.0123 19.2246 15.0123 19.2246 14.9998 19.2246ZM14.8748 12.7746C13.6123 12.7746 12.5873 13.7996 12.5873 15.0621C12.5873 16.2996 13.5498 17.2996 14.7873 17.3496C14.7998 17.3371 14.8998 17.3371 15.0123 17.3496C16.2248 17.2871 17.1623 16.2871 17.1748 15.0621C17.1748 13.8121 16.1498 12.7746 14.8748 12.7746Z"
          fill="currentColor"
        />
        <path
          d="M14.9997 28.4504C13.4997 28.4504 11.9997 28.0629 10.8372 27.2754C9.73723 26.5379 9.09973 25.4879 9.09973 24.3629C9.09973 23.2504 9.72473 22.1754 10.8372 21.4379C13.1747 19.8879 16.8372 19.8879 19.1622 21.4379C20.2622 22.1754 20.8997 23.2254 20.8997 24.3504C20.8997 25.4629 20.2747 26.5379 19.1622 27.2754C17.9997 28.0504 16.4997 28.4504 14.9997 28.4504ZM11.8747 23.0129C11.2872 23.4004 10.9747 23.8879 10.9747 24.3754C10.9747 24.8629 11.2997 25.3379 11.8747 25.7254C13.5622 26.8629 16.4247 26.8629 18.1122 25.7254C18.6997 25.3379 19.0122 24.8504 19.0122 24.3629C19.0122 23.8754 18.6872 23.4004 18.1122 23.0129C16.4372 21.8754 13.5747 21.8879 11.8747 23.0129Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const AgencyIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6249 27.5004H5.0999C3.6499 27.5004 2.4624 26.3379 2.4624 24.9129V6.36294C2.4624 3.08794 4.8999 1.60044 7.8874 3.06294L13.4374 5.78794C14.6374 6.37544 15.6249 7.93794 15.6249 9.26294V27.5004Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27.4625 18.8254V23.5504C27.4625 26.2504 26.2125 27.5004 23.5125 27.5004H15.625V13.0254L16.2125 13.1504L21.8375 14.4129L24.375 14.9754C26.025 15.3379 27.375 16.1879 27.45 18.5879C27.4625 18.6629 27.4625 18.7379 27.4625 18.8254Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.875 11.25H11.2125"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.875 16.25H11.2125"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.8374 14.4129V18.4379C21.8374 19.9879 20.5749 21.2504 19.0249 21.2504C17.4749 21.2504 16.2124 19.9879 16.2124 18.4379V13.1504L21.8374 14.4129Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27.4499 18.5881C27.3749 20.0631 26.1499 21.2506 24.6499 21.2506C23.0999 21.2506 21.8374 19.9881 21.8374 18.4381V14.4131L24.3749 14.9756C26.0249 15.3381 27.3749 16.1881 27.4499 18.5881Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const AgentAgencyIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const SubAgentIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 22V4C6 3.46957 6.24583 2.96086 6.68342 2.58579C7.121 2.21071 7.71449 2 8.33333 2H17.6667C18.2855 2 18.879 2.21071 19.3166 2.58579C19.7542 2.96086 20 3.46957 20 4V22H6Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6H11"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10H11"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 10H16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 6H16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14H16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 18H16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const MemeberIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 14.0625C11.7259 14.0625 13.125 12.6634 13.125 10.9375C13.125 9.21161 11.7259 7.8125 10 7.8125C8.27411 7.8125 6.875 9.21161 6.875 10.9375C6.875 12.6634 8.27411 14.0625 10 14.0625Z"
          stroke="#727272"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3125 9.0625C16.0403 9.0619 16.7582 9.23102 17.4092 9.55645C18.0602 9.88188 18.6263 10.3546 19.0626 10.9372"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.937256 10.9373C1.37354 10.3548 1.93968 9.88196 2.59069 9.5565C3.2417 9.23104 3.95964 9.0619 4.68748 9.0625"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.50269 16.8749C5.91325 16.0317 6.55263 15.3208 7.34785 14.8235C8.14307 14.3262 9.06208 14.0625 9.99999 14.0625C10.9379 14.0625 11.8569 14.3262 12.6521 14.8235C13.4474 15.3208 14.0867 16.0316 14.4973 16.8749"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.68752 9.0625C4.21318 9.06241 3.74865 8.92738 3.34817 8.67316C2.9477 8.41895 2.62781 8.05605 2.42587 7.62684C2.22392 7.19763 2.14825 6.71982 2.2077 6.24921C2.26714 5.77861 2.45924 5.33462 2.76157 4.96911C3.06389 4.60359 3.46397 4.33163 3.91508 4.18498C4.36618 4.03833 4.8497 4.02304 5.30917 4.1409C5.76864 4.25876 6.1851 4.50491 6.50991 4.8506C6.83472 5.19629 7.05449 5.62725 7.14354 6.09316"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8565 6.09314C12.9455 5.62715 13.1653 5.19611 13.4901 4.85034C13.8149 4.50458 14.2314 4.25837 14.6909 4.14046C15.1505 4.02255 15.634 4.03782 16.0852 4.18447C16.5364 4.33113 16.9365 4.60312 17.2389 4.96868C17.5413 5.33424 17.7334 5.77829 17.7928 6.24896C17.8523 6.71963 17.7766 7.1975 17.5746 7.62675C17.3726 8.05601 17.0526 8.41894 16.6521 8.67316C16.2515 8.92738 15.7869 9.06239 15.3125 9.06243"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const ContractIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const FmoIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 13H15M12 10L12 16M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const ChatIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3125 16.8745H3.72396C3.56511 16.8745 3.41276 16.8114 3.30043 16.6991C3.1881 16.5868 3.125 16.4344 3.125 16.2756V9.687C3.125 8.74312 3.31091 7.80849 3.67211 6.93647C4.03332 6.06444 4.56275 5.2721 5.23017 4.60468C5.89759 3.93726 6.68993 3.40783 7.56195 3.04663C8.43398 2.68542 9.36861 2.49951 10.3125 2.49951H10.3125C11.2564 2.49951 12.191 2.68542 13.063 3.04663C13.9351 3.40783 14.7274 3.93726 15.3948 4.60468C16.0623 5.2721 16.5917 6.06445 16.9529 6.93647C17.3141 7.8085 17.5 8.74314 17.5 9.68701V9.68703C17.5 11.5933 16.7427 13.4214 15.3948 14.7693C14.0469 16.1173 12.2188 16.8745 10.3125 16.8745Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0312 10C11.0312 10.397 10.7095 10.7188 10.3125 10.7188C9.91555 10.7188 9.59375 10.397 9.59375 10C9.59375 9.60305 9.91555 9.28125 10.3125 9.28125C10.7095 9.28125 11.0312 9.60305 11.0312 10Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1"
        />
        <path
          d="M14.7812 10C14.7812 10.397 14.4595 10.7188 14.0625 10.7188C13.6655 10.7188 13.3438 10.397 13.3438 10C13.3438 9.60305 13.6655 9.28125 14.0625 9.28125C14.4595 9.28125 14.7812 9.60305 14.7812 10Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1"
        />
        <path
          d="M6.5625 10.7812C6.99397 10.7812 7.34375 10.4315 7.34375 10C7.34375 9.56853 6.99397 9.21875 6.5625 9.21875C6.13103 9.21875 5.78125 9.56853 5.78125 10C5.78125 10.4315 6.13103 10.7812 6.5625 10.7812Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1"
        />
      </svg>
    );
  };
  const ReportIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 21V17M3 17V5C3 3.89543 3.89543 3 5 3H11.5L12.5 4H21L18 10L21 16H12.5L11.5 15H5C3.89543 15 3 15.8954 3 17ZM12 3.5V9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const HelpIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75ZM15.25 12C15.25 13.7949 13.7949 15.25 12 15.25V16.75C14.6234 16.75 16.75 14.6234 16.75 12H15.25ZM12 15.25C10.2051 15.25 8.75 13.7949 8.75 12H7.25C7.25 14.6234 9.37665 16.75 12 16.75V15.25ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75V7.25C9.37665 7.25 7.25 9.37665 7.25 12H8.75ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12H16.75C16.75 9.37665 14.6234 7.25 12 7.25V8.75ZM17.8336 5.10571L14.2981 8.64124L15.3588 9.7019L18.8943 6.16637L17.8336 5.10571ZM14.2981 15.3588L17.8336 18.8943L18.8943 17.8336L15.3588 14.2981L14.2981 15.3588ZM9.7019 8.64124L6.16637 5.10571L5.10571 6.16637L8.64124 9.7019L9.7019 8.64124ZM8.64124 14.2981L5.10571 17.8336L6.16637 18.8943L9.7019 15.3588L8.64124 14.2981Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const SettingIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const SearchIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5 19.5C17.1569 17.1569 18.3431 18.3431 16 16M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const CaretIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.6"
          d="M15.4453 8.68359L16.5 9.73828L12 14.2383L7.5 9.73828L8.55469 8.68359L12 12.1289L15.4453 8.68359Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CaretLeftIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.126 1.7925L5.8335 0.5L0.333496 6L5.8335 11.5L7.126 10.2075L2.92766 6L7.126 1.7925Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CaretRightIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.89602 0.5L0.603516 1.7925L4.80185 6L0.603516 10.2075L1.89602 11.5L7.39602 6L1.89602 0.5Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const MoreHIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 12H5.01M12 12H12.01M19 12H19.01M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const OpenTaskIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.10355 10.1464C6.90829 9.95118 6.59171 9.95118 6.39645 10.1464C6.20118 10.3417 6.20118 10.6583 6.39645 10.8536L7.10355 10.1464ZM8.25 12L7.89645 12.3536C8.09171 12.5488 8.40829 12.5488 8.60355 12.3536L8.25 12ZM11.6036 9.35355C11.7988 9.15829 11.7988 8.84171 11.6036 8.64645C11.4083 8.45118 11.0917 8.45118 10.8964 8.64645L11.6036 9.35355ZM13.75 5.25V14.25H14.75V5.25H13.75ZM12.75 15.25H5.25V16.25H12.75V15.25ZM4.25 14.25V5.25H3.25V14.25H4.25ZM5.25 4.25H6.75V3.25H5.25V4.25ZM11.25 4.25H12.75V3.25H11.25V4.25ZM5.25 15.25C4.69772 15.25 4.25 14.8023 4.25 14.25H3.25C3.25 15.3546 4.14543 16.25 5.25 16.25V15.25ZM13.75 14.25C13.75 14.8023 13.3023 15.25 12.75 15.25V16.25C13.8546 16.25 14.75 15.3546 14.75 14.25H13.75ZM14.75 5.25C14.75 4.14543 13.8546 3.25 12.75 3.25V4.25C13.3023 4.25 13.75 4.69772 13.75 5.25H14.75ZM4.25 5.25C4.25 4.69772 4.69772 4.25 5.25 4.25V3.25C4.14543 3.25 3.25 4.14543 3.25 5.25H4.25ZM6.39645 10.8536L7.89645 12.3536L8.60355 11.6464L7.10355 10.1464L6.39645 10.8536ZM8.60355 12.3536L11.6036 9.35355L10.8964 8.64645L7.89645 11.6464L8.60355 12.3536ZM8.25 2.75H9.75V1.75H8.25V2.75ZM9.75 4.75H8.25V5.75H9.75V4.75ZM8.25 4.75C7.69772 4.75 7.25 4.30228 7.25 3.75H6.25C6.25 4.85457 7.14543 5.75 8.25 5.75V4.75ZM10.75 3.75C10.75 4.30228 10.3023 4.75 9.75 4.75V5.75C10.8546 5.75 11.75 4.85457 11.75 3.75H10.75ZM9.75 2.75C10.3023 2.75 10.75 3.19772 10.75 3.75H11.75C11.75 2.64543 10.8546 1.75 9.75 1.75V2.75ZM8.25 1.75C7.14543 1.75 6.25 2.64543 6.25 3.75H7.25C7.25 3.19772 7.69772 2.75 8.25 2.75V1.75Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const CallCutIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6665 6L14.1665 4.5M14.1665 4.5L15.6665 3M14.1665 4.5L12.6665 3M14.1665 4.5L15.6665 6M4.4165 2.25C3.58808 2.25 2.9165 2.92157 2.9165 3.75V4.5C2.9165 10.7132 7.9533 15.75 14.1665 15.75H14.9165C15.7449 15.75 16.4165 15.0784 16.4165 14.25V11.7906C16.4165 11.4677 16.2099 11.1811 15.9037 11.0791L12.5336 9.9557C12.1795 9.83767 11.7925 9.99796 11.6256 10.3318L10.7791 12.0247C8.94559 11.1981 7.46844 9.72091 6.64176 7.88737L8.3347 7.0409C8.66854 6.87398 8.82883 6.48699 8.71081 6.13291L7.58745 2.76283C7.48536 2.45657 7.19876 2.25 6.87593 2.25H4.4165Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const MailIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 6.66602L9.0755 11.0497C9.63533 11.4229 10.3647 11.4229 10.9245 11.0497L17.5 6.66602M4.16667 15.8327H15.8333C16.7538 15.8327 17.5 15.0865 17.5 14.166V5.83268C17.5 4.91221 16.7538 4.16602 15.8333 4.16602H4.16667C3.24619 4.16602 2.5 4.91221 2.5 5.83268V14.166C2.5 15.0865 3.24619 15.8327 4.16667 15.8327Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const AddIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.00016 1.33398V14.6673M14.6668 8.00065L1.3335 8.00065"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const MinusIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 16 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1H15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const ImportIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.6665 7.5V4.16667C1.6665 3.25 2.4165 2.5 3.33317 2.5H6.60817C6.88268 2.50142 7.15259 2.57063 7.39392 2.70147C7.63525 2.83231 7.84052 3.02073 7.9915 3.25L8.67484 4.25C8.82582 4.47927 9.03109 4.66769 9.27242 4.79853C9.51375 4.92937 9.78366 4.99858 10.0582 5H16.6665C17.1085 5 17.5325 5.17559 17.845 5.48816C18.1576 5.80072 18.3332 6.22464 18.3332 6.66667V15C18.3332 15.442 18.1576 15.866 17.845 16.1785C17.5325 16.4911 17.1085 16.6667 16.6665 16.6667H3.33317C2.89114 16.6667 2.46722 16.4911 2.15466 16.1785C1.8421 15.866 1.6665 15.442 1.6665 15V14.1667"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.6665 10.834H9.99984"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 13.334L10 10.834L7.5 8.33398"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const EditIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.66602 17.9577H2.33268C1.72489 17.9577 1.142 17.7162 0.712229 17.2865C0.282458 16.8567 0.0410156 16.2738 0.0410156 15.666V2.33268C0.0410156 1.72489 0.282458 1.142 0.712229 0.712229C1.142 0.282458 1.72489 0.0410156 2.33268 0.0410156H12.3327C12.9405 0.0410156 13.5234 0.282458 13.9531 0.712229C14.3829 1.142 14.6243 1.72489 14.6243 2.33268V6.19102C14.6243 6.35678 14.5585 6.51575 14.4413 6.63296C14.3241 6.75017 14.1651 6.81602 13.9993 6.81602C13.8336 6.81602 13.6746 6.75017 13.5574 6.63296C13.4402 6.51575 13.3743 6.35678 13.3743 6.19102V2.33268C13.3743 2.05641 13.2646 1.79146 13.0693 1.59611C12.8739 1.40076 12.609 1.29102 12.3327 1.29102H2.33268C2.05642 1.29102 1.79146 1.40076 1.59611 1.59611C1.40076 1.79146 1.29102 2.05641 1.29102 2.33268V15.666C1.29102 15.9423 1.40076 16.2072 1.59611 16.4026C1.79146 16.5979 2.05642 16.7077 2.33268 16.7077H5.66602C5.83178 16.7077 5.99075 16.7735 6.10796 16.8907C6.22517 17.0079 6.29102 17.1669 6.29102 17.3327C6.29102 17.4984 6.22517 17.6574 6.10796 17.7746C5.99075 17.8918 5.83178 17.9577 5.66602 17.9577ZM8.99935 17.9577C8.83364 17.9575 8.67478 17.8916 8.55768 17.7743C8.43994 17.6542 8.37411 17.4926 8.37435 17.3243V14.941C8.37365 14.8601 8.38955 14.7799 8.42109 14.7053C8.45262 14.6308 8.49911 14.5635 8.55768 14.5077L13.666 9.39102C14.103 8.97478 14.6834 8.7426 15.2868 8.7426C15.8903 8.7426 16.4707 8.97478 16.9077 9.39102C17.3357 9.82189 17.5758 10.4045 17.5758 11.0118C17.5758 11.6191 17.3357 12.2018 16.9077 12.6327L11.791 17.741C11.7352 17.7996 11.6679 17.8461 11.5934 17.8776C11.5188 17.9091 11.4386 17.925 11.3577 17.9243H8.97435L8.99935 17.9577ZM9.64935 15.241V16.7327H11.141L16.0743 11.7993C16.1714 11.7026 16.2483 11.5876 16.3008 11.4611C16.3533 11.3345 16.3804 11.1989 16.3804 11.0618C16.3804 10.9248 16.3533 10.7892 16.3008 10.6626C16.2483 10.5361 16.1714 10.4211 16.0743 10.3243C15.8749 10.1362 15.611 10.0315 15.3368 10.0315C15.0627 10.0315 14.7988 10.1362 14.5993 10.3243L9.64935 15.241ZM6.49935 13.791H3.99935C3.83359 13.791 3.67462 13.7252 3.55741 13.608C3.4402 13.4907 3.37435 13.3318 3.37435 13.166C3.37435 13.0003 3.4402 12.8413 3.55741 12.7241C3.67462 12.6069 3.83359 12.541 3.99935 12.541H6.49935C6.66511 12.541 6.82408 12.6069 6.94129 12.7241C7.0585 12.8413 7.12435 13.0003 7.12435 13.166C7.12435 13.3318 7.0585 13.4907 6.94129 13.608C6.82408 13.7252 6.66511 13.791 6.49935 13.791ZM10.666 9.62435H3.99935C3.83359 9.62435 3.67462 9.5585 3.55741 9.44129C3.4402 9.32408 3.37435 9.16511 3.37435 8.99935C3.37435 8.83359 3.4402 8.67462 3.55741 8.55741C3.67462 8.4402 3.83359 8.37435 3.99935 8.37435H10.666C10.8318 8.37435 10.9907 8.4402 11.108 8.55741C11.2252 8.67462 11.291 8.83359 11.291 8.99935C11.291 9.16511 11.2252 9.32408 11.108 9.44129C10.9907 9.5585 10.8318 9.62435 10.666 9.62435ZM10.666 5.45768H3.99935C3.83359 5.45768 3.67462 5.39183 3.55741 5.27462C3.4402 5.15741 3.37435 4.99844 3.37435 4.83268C3.37435 4.66692 3.4402 4.50795 3.55741 4.39074C3.67462 4.27353 3.83359 4.20768 3.99935 4.20768H10.666C10.8318 4.20768 10.9907 4.27353 11.108 4.39074C11.2252 4.50795 11.291 4.66692 11.291 4.83268C11.291 4.99844 11.2252 5.15741 11.108 5.27462C10.9907 5.39183 10.8318 5.45768 10.666 5.45768Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const TrashIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4165 4.41667L14.6215 15.5473C14.5529 16.5067 13.7546 17.25 12.7928 17.25H5.20689C4.24505 17.25 3.44674 16.5067 3.37821 15.5473L2.58317 4.41667M7.1665 8.08333V13.5833M10.8332 8.08333V13.5833M11.7498 4.41667V1.66667C11.7498 1.16041 11.3394 0.75 10.8332 0.75H7.1665C6.66024 0.75 6.24984 1.16041 6.24984 1.66667V4.41667M1.6665 4.41667H16.3332"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const TrashIcon2 = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.34997 1.25 8.12997 2.57 7.96997 3.54L7.75997 4.82C6.82997 4.88 5.89997 4.94 4.96997 5.03L2.92997 5.23C2.50997 5.27 2.20997 5.64 2.24997 6.05C2.28997 6.46 2.64997 6.76 3.06997 6.72L5.10997 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z"
          fill="currentColor"
        />
        <path
          d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14ZM13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75ZM14.5 13.75H9.49999C9.08999 13.75 8.74999 13.41 8.74999 13C8.74999 12.59 9.08999 12.25 9.49999 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const FilterIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12H18M3 6H21M9 18H15"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const FileIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.49984 9H9.49984M4.49984 12.3333H9.49984M11.1665 16.5H2.83317C1.9127 16.5 1.1665 15.7538 1.1665 14.8333V3.16667C1.1665 2.24619 1.9127 1.5 2.83317 1.5H7.48799C7.70901 1.5 7.92097 1.5878 8.07725 1.74408L12.5891 6.25592C12.7454 6.4122 12.8332 6.62416 12.8332 6.84518V14.8333C12.8332 15.7538 12.087 16.5 11.1665 16.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const CallLineIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterLimit="10"
        />
      </svg>
    );
  };

  const LocationIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M21 10.8889C21 15.7981 15.375 22 12 22C8.625 22 3 15.7981 3 10.8889C3 5.97969 7.02944 2 12 2C16.9706 2 21 5.97969 21 10.8889Z"
          fill="currentColor"
        />
        <circle cx="12" cy="11" r="3" fill="currentColor" />
      </svg>
    );
  };
  const ClockIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const DollerCircleIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.67188 14.4627C8.67188 15.7527 9.66188 16.7927 10.8919 16.7927H13.4019C14.4719 16.7927 15.3419 15.8827 15.3419 14.7627C15.3419 13.5427 14.8119 13.1127 14.0219 12.8327L9.99187 11.4327C9.20187 11.1527 8.67188 10.7227 8.67188 9.50266C8.67188 8.38266 9.54187 7.47266 10.6119 7.47266H13.1219C14.3519 7.47266 15.3419 8.51266 15.3419 9.80266"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6.13281V18.1328"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 22.1328C17.5228 22.1328 22 17.6557 22 12.1328C22 6.60996 17.5228 2.13281 12 2.13281C6.47715 2.13281 2 6.60996 2 12.1328C2 17.6557 6.47715 22.1328 12 22.1328Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const StarIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.30001 14.46C5.65001 14.81 5.85001 15.51 5.74001 16L5.22001 18.25C5.18001 18.45 4.90713 20.5603 5.05001 20.95C5.16001 21.25 5.33001 21.48 5.56001 21.65C6.17001 22.1 7.12001 21.99 8.23001 21.34L11.16 19.6C11.62 19.33 12.38 19.33 12.84 19.6L15.77 21.34C16.43 21.73 17.03 21.92 17.54 21.92C17.89 21.92 18.19 21.83 18.44 21.65C19.06 21.2 19.24 20.26 18.95 19.01L18.26 16C18.14 15.51 18.34 14.82 18.7 14.46L21.12 12.03C21.88 11.27 22.18 10.46 21.96 9.76C21.73 9.06 21.02 8.58 19.96 8.4L18.95 8.23C18.32 8.12 16.62 7.84 16.33 7.67C16.04 7.5 15.77 7.25 15.64 6.99L13.92 3.54C13.42 2.55 12.74 2 12 2C11.26 2 10.58 2.55 10.08 3.54L8.36001 6.99C8.15001 7.4 7.60001 7.8 7.15001 7.88L4.03001 8.4C2.97001 8.58 2.26001 9.06 2.03001 9.76C1.81001 10.46 2.11001 11.27 2.87001 12.03L5.30001 14.46Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const SettingClickIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.88892 9.99963L8.88892 11.9996L12.8889 7.99963M5.72365 2.69668C6.44119 2.63942 7.12237 2.35727 7.67023 1.89038C8.94872 0.800862 10.8291 0.800862 12.1076 1.89038C12.6555 2.35727 13.3366 2.63942 14.0542 2.69668C15.7286 2.8303 17.0582 4.15994 17.1919 5.83437C17.2491 6.55191 17.5313 7.23309 17.9982 7.78095C19.0877 9.05944 19.0877 10.9398 17.9982 12.2183C17.5313 12.7662 17.2491 13.4474 17.1919 14.1649C17.0582 15.8393 15.7286 17.169 14.0542 17.3026C13.3366 17.3598 12.6555 17.642 12.1076 18.1089C10.8291 19.1984 8.94872 19.1984 7.67023 18.1089C7.12237 17.642 6.44119 17.3598 5.72365 17.3026C4.04922 17.169 2.71958 15.8393 2.58596 14.1649C2.5287 13.4474 2.24655 12.7662 1.77966 12.2183C0.690145 10.9398 0.690145 9.05944 1.77966 7.78095C2.24655 7.23309 2.5287 6.55191 2.58596 5.83437C2.71958 4.15994 4.04922 2.8303 5.72365 2.69668Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const CheckIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4605 8.40802C16.7874 8.66232 16.8463 9.13353 16.592 9.46049L12.585 14.6123C11.9613 15.4143 10.7881 15.5183 10.033 14.8387L7.49828 12.5575C7.1904 12.2804 7.16544 11.8062 7.44254 11.4983C7.71963 11.1904 8.19385 11.1655 8.50173 11.4426L11.0364 13.7238C11.1443 13.8209 11.3119 13.806 11.401 13.6914L15.408 8.53958C15.6623 8.21262 16.1335 8.15372 16.4605 8.40802Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const InfoIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          fill="currentColor"
        />
        <path
          d="M12 13.75C12.41 13.75 12.75 13.41 12.75 13V8C12.75 7.59 12.41 7.25 12 7.25C11.59 7.25 11.25 7.59 11.25 8V13C11.25 13.41 11.59 13.75 12 13.75Z"
          fill="currentColor"
        />
        <path
          d="M12.92 15.6199C12.87 15.4999 12.8 15.3899 12.71 15.2899C12.61 15.1999 12.5 15.1299 12.38 15.0799C12.14 14.9799 11.86 14.9799 11.62 15.0799C11.5 15.1299 11.39 15.1999 11.29 15.2899C11.2 15.3899 11.13 15.4999 11.08 15.6199C11.03 15.7399 11 15.8699 11 15.9999C11 16.1299 11.03 16.2599 11.08 16.3799C11.13 16.5099 11.2 16.6099 11.29 16.7099C11.39 16.7999 11.5 16.8699 11.62 16.9199C11.74 16.9699 11.87 16.9999 12 16.9999C12.13 16.9999 12.26 16.9699 12.38 16.9199C12.5 16.8699 12.61 16.7999 12.71 16.7099C12.8 16.6099 12.87 16.5099 12.92 16.3799C12.97 16.2599 13 16.1299 13 15.9999C13 15.8699 12.97 15.7399 12.92 15.6199Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const DoubleArrowLeftIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 17L13 12L18 7M11 17L6 12L11 7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const DoubleArrowRightIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 17L11 12L6 7M13 17L18 12L13 7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const ArrowRightIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const ArrowLeftIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const SunIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.002 18.5C15.5918 18.5 18.502 15.5899 18.502 12C18.502 8.41015 15.5918 5.5 12.002 5.5C8.4121 5.5 5.50195 8.41015 5.50195 12C5.50195 15.5899 8.4121 18.5 12.002 18.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M19.142 19.14L19.012 19.01M19.012 4.99L19.142 4.86L19.012 4.99ZM4.86195 19.14L4.99195 19.01L4.86195 19.14ZM12.002 2.08V2V2.08ZM12.002 22V21.92V22ZM2.08195 12H2.00195H2.08195ZM22.002 12H21.922H22.002ZM4.99195 4.99L4.86195 4.86L4.99195 4.99Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const HalfSunIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.502 12C18.502 8.41 15.592 5.5 12.002 5.5C8.41195 5.5 5.50195 8.41 5.50195 12"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.99194 4.98999L4.86194 4.85999M19.012 4.98999L19.142 4.85999L19.012 4.98999ZM12.002 2.07999V2V2.07999ZM2.08197 12H2.00195H2.08197ZM22.002 12H21.9219H22.002Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M4.00195 15H20.002"
          stroke="currentColor"
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.00195 18H18.002"
          stroke="currentColor"
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M9.00195 21H15.002"
          stroke="currentColor"
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const MoonIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.03204 12.42C2.39204 17.57 6.76204 21.76 11.992 21.99C15.682 22.15 18.982 20.43 20.962 17.72C21.782 16.61 21.342 15.87 19.972 16.12C19.302 16.24 18.612 16.29 17.892 16.26C13.002 16.06 9.00204 11.97 8.98204 7.13996C8.97204 5.83996 9.24204 4.60996 9.73204 3.48996C10.272 2.24996 9.62204 1.65996 8.37204 2.18996C4.41204 3.85996 1.70204 7.84996 2.03204 12.42Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const PinIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.502 12C13.502 15.18 10.932 17.75 7.75195 17.75C4.57195 17.75 2.00195 15.18 2.00195 12C2.00195 8.82 4.57195 6.25 7.75195 6.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M10.002 12C10.002 8.69 12.692 6 16.002 6C19.312 6 22.002 8.69 22.002 12C22.002 15.31 19.312 18 16.002 18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const SendIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.51002 4.22989L18.07 8.50989C21.91 10.4299 21.91 13.5699 18.07 15.4899L9.51002 19.7699C3.75002 22.6499 1.40002 20.2899 4.28002 14.5399L5.15002 12.8099C5.37002 12.3699 5.37002 11.6399 5.15002 11.1999L4.28002 9.45989C1.40002 3.70989 3.76002 1.34989 9.51002 4.22989Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.44 12H10.84"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  const SmileIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 15C9 15 10.125 16 12 16C13.875 16 15 15 15 15M17 10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9C16.5523 9 17 9.44772 17 10ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const GlobeIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.5 15C27.5 21.9036 21.9036 27.5 15 27.5M27.5 15C27.5 8.09644 21.9036 2.5 15 2.5M27.5 15C27.5 12.9289 21.9036 11.25 15 11.25C8.09644 11.25 2.5 12.9289 2.5 15M27.5 15C27.5 17.0711 21.9036 18.75 15 18.75C8.09644 18.75 2.5 17.0711 2.5 15M15 27.5C8.09644 27.5 2.5 21.9036 2.5 15M15 27.5C17.7614 27.5 20 21.9036 20 15C20 8.09644 17.7614 2.5 15 2.5M15 27.5C12.2386 27.5 10 21.9036 10 15C10 8.09644 12.2386 2.5 15 2.5M2.5 15C2.5 8.09644 8.09644 2.5 15 2.5"
          stroke="currentColor"
          stroke-width="1.5"
        />
      </svg>
    );
  };
  const DownLoadIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 12H16L12 17L8 12H11V8H13V12Z"></path>
      </svg>
    );
  };
  const AttachmentIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M14 13.5V8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8V13.5C6 17.0899 8.91015 20 12.5 20C16.0899 20 19 17.0899 19 13.5V4H21V13.5C21 18.1944 17.1944 22 12.5 22C7.80558 22 4 18.1944 4 13.5V8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8V13.5C16 15.433 14.433 17 12.5 17C10.567 17 9 15.433 9 13.5V8H11V13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5Z"></path>
      </svg>
    );
  };
  const MemberIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8311 14.525C11.7923 14.525 11.7665 14.525 11.7277 14.525C11.6632 14.5125 11.5727 14.5125 11.4952 14.525C7.7494 14.4125 4.92065 11.5625 4.92065 8.05C4.92065 4.475 7.93024 1.5625 11.6244 1.5625C15.3186 1.5625 18.3282 4.475 18.3282 8.05C18.3152 11.5625 15.4736 14.4125 11.8698 14.525C11.8569 14.525 11.844 14.525 11.8311 14.525ZM11.6244 3.4375C9.00232 3.4375 6.85815 5.5125 6.85815 8.05C6.85815 10.55 8.87315 12.5625 11.4436 12.65C11.5211 12.6375 11.689 12.6375 11.8569 12.65C14.3886 12.5375 16.3777 10.525 16.3907 8.05C16.3907 5.5125 14.2465 3.4375 11.6244 3.4375Z"
          fill="currentColor"
        />
        <path
          d="M21.3636 14.6875C21.3248 14.6875 21.2861 14.6875 21.2473 14.675C20.7177 14.725 20.1752 14.3625 20.1236 13.85C20.0719 13.3375 20.3948 12.875 20.9244 12.8125C21.0794 12.8 21.2473 12.8 21.3894 12.8C23.2752 12.7 24.7477 11.2 24.7477 9.3625C24.7477 7.4625 23.159 5.925 21.1956 5.925C20.6661 5.9375 20.2269 5.5125 20.2269 5C20.2269 4.4875 20.6661 4.0625 21.1956 4.0625C24.2181 4.0625 26.6852 6.45 26.6852 9.375C26.6852 12.25 24.3602 14.575 21.4023 14.6875C21.3894 14.6875 21.3765 14.6875 21.3636 14.6875Z"
          fill="currentColor"
        />
        <path
          d="M11.8441 28.1875C9.31241 28.1875 6.76783 27.5625 4.84325 26.3125C3.04783 25.1625 2.06616 23.5875 2.06616 21.875C2.06616 20.1625 3.04783 18.575 4.84325 17.4125C8.71825 14.925 14.9957 14.925 18.8449 17.4125C20.6274 18.5625 21.622 20.1375 21.622 21.85C21.622 23.5625 20.6403 25.15 18.8449 26.3125C16.9074 27.5625 14.3757 28.1875 11.8441 28.1875ZM5.91533 18.9875C4.67533 19.7875 4.00366 20.8125 4.00366 21.8875C4.00366 22.95 4.68825 23.975 5.91533 24.7625C9.13158 26.85 14.5566 26.85 17.7728 24.7625C19.0128 23.9625 19.6845 22.9375 19.6845 21.8625C19.6845 20.8 18.9999 19.775 17.7728 18.9875C14.5566 16.9125 9.13158 16.9125 5.91533 18.9875Z"
          fill="currentColor"
        />
        <path
          d="M23.6886 25.9375C23.2366 25.9375 22.8361 25.6375 22.7457 25.1875C22.6424 24.675 22.9782 24.1875 23.4949 24.075C24.3086 23.9125 25.0578 23.6 25.6391 23.1625C26.3753 22.625 26.7757 21.95 26.7757 21.2375C26.7757 20.525 26.3753 19.85 25.652 19.325C25.0836 18.9 24.3732 18.6 23.5336 18.4125C23.017 18.3 22.6811 17.8 22.7974 17.2875C22.9136 16.7875 23.4303 16.4625 23.9599 16.575C25.0707 16.8125 26.0395 17.2375 26.8274 17.825C28.0286 18.7 28.7132 19.9375 28.7132 21.2375C28.7132 22.5375 28.0157 23.775 26.8145 24.6625C26.0136 25.2625 25.0061 25.7 23.8953 25.9125C23.8178 25.9375 23.7532 25.9375 23.6886 25.9375Z"
          fill="currentColor"
        />
      </svg>
    );
  };
  const InviteSmsIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.66666 6H6.33333"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 7.66665V4.33331"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 6V12.5C2 12.6326 2.05268 12.7598 2.14645 12.8536C2.24021 12.9473 2.36739 13 2.5 13H13.5C13.6326 13 13.7598 12.9473 13.8536 12.8536C13.9473 12.7598 14 12.6326 14 12.5V6L8 2L2 6Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.90921 9.5L2.1543 12.8587"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.8458 12.8587L9.09082 9.5"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 6L9.09094 9.5H6.90906L2 6"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const PhoneProIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 1.875H6.25C5.55964 1.875 5 2.43464 5 3.125V16.875C5 17.5654 5.55964 18.125 6.25 18.125H13.75C14.4404 18.125 15 17.5654 15 16.875V3.125C15 2.43464 14.4404 1.875 13.75 1.875Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 4.375H15"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 15.625H15"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  const IpadeIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 3.75L3.75 16.25C3.75 16.9404 4.30964 17.5 5 17.5H15C15.6904 17.5 16.25 16.9404 16.25 16.25V3.75C16.25 3.05964 15.6904 2.5 15 2.5H5C4.30964 2.5 3.75 3.05964 3.75 3.75Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.81875 14.6875C9.81875 14.5874 9.8999 14.5063 10 14.5063C10.1001 14.5063 10.1812 14.5874 10.1812 14.6875C10.1812 14.7876 10.1001 14.8687 10 14.8687C9.8999 14.8687 9.81875 14.7876 9.81875 14.6875Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1.2"
        />
      </svg>
    );
  };
  const DesktopIcon = ({ width, height }) => {
    return (
      <svg
        width={width || fallbackWidth}
        height={height || fallbackHeight}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 15L16.25 15C16.9404 15 17.5 14.4404 17.5 13.75V5C17.5 4.30964 16.9404 3.75 16.25 3.75L3.75 3.75C3.05964 3.75 2.5 4.30964 2.5 5L2.5 13.75C2.5 14.4404 3.05964 15 3.75 15Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 17.5H7.5"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.5 11.875H17.5"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 15V17.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  return {
    UserIcon,
    AttachmentIcon,
    GroupIcon,
    DashboardIcon,
    ListIcon,
    CallIcon,
    CallRecordIcon,
    VoicemailIcon,
    CallHistoryIcon,
    ProfileIcon,
    LogoutIcon,
    MoreVIcon,
    CrossRoundIcon,
    RefreshIcon,
    CaretIcon,
    PencilIcon,
    BellIcon,
    BackAngleIcon,
    BackRoundIcon,
    WarningOutlineIcon,
    SuccessOutlineIcon,
    InfoOutlineIcon,
    AppleIcon,
    GoogleIcon,
    HomeIcon,
    CalendarIcon,
    AgentsIcon,
    AgentInfoIcon,
    AgentAgencyIcon,
    AgencyIcon,
    SubAgentIcon,
    MemeberIcon,
    ContractIcon,
    FmoIcon,
    ChatIcon,
    ReportIcon,
    HelpIcon,
    SettingIcon,
    SearchIcon,
    ChangeStatusIcon,
    MoreHIcon,
    OpenTaskIcon,
    CallCutIcon,
    MailIcon,
    CrossIcon,
    CaretLeftIcon,
    CaretRightIcon,
    ImportIcon,
    AddIcon,
    MinusIcon,
    EditIcon,
    TrashIcon,
    TrashIcon2,
    FilterIcon,
    FileIcon,
    CallLineIcon,
    LocationIcon,
    ClockIcon,
    DollerCircleIcon,
    StarIcon,
    SettingClickIcon,
    CheckIcon,
    InfoIcon,
    SunIcon,
    HalfSunIcon,
    MoonIcon,
    PinIcon,
    SendIcon,
    SmileIcon,
    UserLineIcon,
    DoubleArrowLeftIcon,
    DoubleArrowRightIcon,
    ArrowRightIcon,
    ArrowLeftIcon,
    GlobeIcon,
    MemberIcon,
    DownLoadIcon,
    InviteSmsIcon,
    PhoneProIcon,
    IpadeIcon,
    DesktopIcon,
    CameraIcon,
  };
}
export const InviteIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M17.08 14.1499C14.29 12.2899 9.73996 12.2899 6.92996 14.1499C5.65996 14.9999 4.95996 16.1499 4.95996 17.3799C4.95996 18.6099 5.65996 19.7499 6.91996 20.5899C8.31996 21.5299 10.16 21.9999 12 21.9999C13.84 21.9999 15.68 21.5299 17.08 20.5899C18.34 19.7399 19.04 18.5999 19.04 17.3599C19.03 16.1299 18.34 14.9899 17.08 14.1499Z"
        fill="currentColor"
      />
      <path
        d="M14 16.6299H12.75V15.3799C12.75 14.9699 12.41 14.6299 12 14.6299C11.59 14.6299 11.25 14.9699 11.25 15.3799V16.6299H10C9.59 16.6299 9.25 16.9699 9.25 17.3799C9.25 17.7899 9.59 18.1299 10 18.1299H11.25V19.3799C11.25 19.7899 11.59 20.1299 12 20.1299C12.41 20.1299 12.75 19.7899 12.75 19.3799V18.1299H14C14.41 18.1299 14.75 17.7899 14.75 17.3799C14.75 16.9699 14.41 16.6299 14 16.6299Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UploadImg = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0015 13.9001V16.1901C22.0015 19.8301 19.8315 22.0001 16.1915 22.0001H7.81152C5.26152 22.0001 3.42152 20.9301 2.56152 19.0301L2.67152 18.9501L7.59152 15.6501C8.39152 15.1101 9.52152 15.1701 10.2315 15.7901L10.5715 16.0701C11.3515 16.7401 12.6115 16.7401 13.3915 16.0701L17.5515 12.5001C18.3315 11.8301 19.5915 11.8301 20.3715 12.5001L22.0015 13.9001Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M20.972 8H18.032C16.762 8 16.002 7.24 16.002 5.97V3.03C16.002 2.63 16.082 2.29 16.222 2C16.212 2 16.202 2 16.192 2H7.81195C4.17195 2 2.00195 4.17 2.00195 7.81V16.19C2.00195 17.28 2.19195 18.23 2.56195 19.03L2.67195 18.95L7.59195 15.65C8.39195 15.11 9.52195 15.17 10.232 15.79L10.572 16.07C11.352 16.74 12.612 16.74 13.392 16.07L17.552 12.5C18.332 11.83 19.592 11.83 20.372 12.5L22.002 13.9V7.81C22.002 7.8 22.002 7.79 22.002 7.78C21.712 7.92 21.372 8 20.972 8Z"
        fill="currentColor"
      />
      <path
        d="M9.00207 10.3801C10.3165 10.3801 11.3821 9.31456 11.3821 8.00012C11.3821 6.68568 10.3165 5.62012 9.00207 5.62012C7.68763 5.62012 6.62207 6.68568 6.62207 8.00012C6.62207 9.31456 7.68763 10.3801 9.00207 10.3801Z"
        fill="currentColor"
      />
      <path
        d="M20.972 1H18.032C16.762 1 16.002 1.76 16.002 3.03V5.97C16.002 7.24 16.762 8 18.032 8H20.972C22.242 8 23.002 7.24 23.002 5.97V3.03C23.002 1.76 22.242 1 20.972 1ZM21.192 4.31C21.072 4.43 20.912 4.49 20.752 4.49C20.592 4.49 20.432 4.43 20.312 4.31L20.132 4.13V6.37C20.132 6.72 19.852 7 19.502 7C19.152 7 18.872 6.72 18.872 6.37V4.13L18.692 4.31C18.452 4.55 18.052 4.55 17.812 4.31C17.572 4.07 17.572 3.67 17.812 3.43L19.062 2.18C19.112 2.13 19.182 2.09 19.252 2.06C19.272 2.05 19.292 2.05 19.312 2.04C19.362 2.02 19.412 2.01 19.472 2.01C19.492 2.01 19.512 2.01 19.532 2.01C19.602 2.01 19.662 2.02 19.732 2.05C19.742 2.05 19.742 2.05 19.752 2.05C19.822 2.08 19.882 2.12 19.932 2.17C19.942 2.18 19.942 2.18 19.952 2.18L21.202 3.43C21.442 3.67 21.442 4.07 21.192 4.31Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SignedConsents = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.62 9.62012H12.37C11.96 9.62012 11.62 9.28012 11.62 8.87012C11.62 8.46012 11.96 8.12012 12.37 8.12012H17.62C18.03 8.12012 18.37 8.46012 18.37 8.87012C18.37 9.28012 18.04 9.62012 17.62 9.62012Z"
        fill="currentColor"
      />
      <path
        d="M7.12006 10.3801C6.93006 10.3801 6.74006 10.3101 6.59006 10.1601L5.84006 9.41007C5.55006 9.12007 5.55006 8.64007 5.84006 8.35007C6.13006 8.06007 6.61006 8.06007 6.90006 8.35007L7.12006 8.57007L8.84006 6.85007C9.13006 6.56007 9.61006 6.56007 9.90006 6.85007C10.1901 7.14007 10.1901 7.62007 9.90006 7.91007L7.65006 10.1601C7.51006 10.3001 7.32006 10.3801 7.12006 10.3801Z"
        fill="currentColor"
      />
      <path
        d="M17.62 16.6201H12.37C11.96 16.6201 11.62 16.2801 11.62 15.8701C11.62 15.4601 11.96 15.1201 12.37 15.1201H17.62C18.03 15.1201 18.37 15.4601 18.37 15.8701C18.37 16.2801 18.04 16.6201 17.62 16.6201Z"
        fill="currentColor"
      />
      <path
        d="M7.12006 17.3801C6.93006 17.3801 6.74006 17.3101 6.59006 17.1601L5.84006 16.4101C5.55006 16.1201 5.55006 15.6401 5.84006 15.3501C6.13006 15.0601 6.61006 15.0601 6.90006 15.3501L7.12006 15.5701L8.84006 13.8501C9.13006 13.5601 9.61006 13.5601 9.90006 13.8501C10.1901 14.1401 10.1901 14.6201 9.90006 14.9101L7.65006 17.1601C7.51006 17.3001 7.32006 17.3801 7.12006 17.3801Z"
        fill="currentColor"
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SignedEligibilities = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.31006 14.7L10.8101 16.2L14.8101 12.2"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LightTheme = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.002 19C15.8679 19 19.002 15.866 19.002 12C19.002 8.13401 15.8679 5 12.002 5C8.13596 5 5.00195 8.13401 5.00195 12C5.00195 15.866 8.13596 19 12.002 19Z"
        fill="currentColor"
      />
      <path
        d="M12.002 22.96C11.452 22.96 11.002 22.55 11.002 22V21.92C11.002 21.37 11.452 20.92 12.002 20.92C12.552 20.92 13.002 21.37 13.002 21.92C13.002 22.47 12.552 22.96 12.002 22.96ZM19.142 20.14C18.882 20.14 18.632 20.04 18.432 19.85L18.302 19.72C17.912 19.33 17.912 18.7 18.302 18.31C18.692 17.92 19.322 17.92 19.712 18.31L19.842 18.44C20.232 18.83 20.232 19.46 19.842 19.85C19.652 20.04 19.402 20.14 19.142 20.14ZM4.86195 20.14C4.60195 20.14 4.35195 20.04 4.15195 19.85C3.76195 19.46 3.76195 18.83 4.15195 18.44L4.28195 18.31C4.67195 17.92 5.30195 17.92 5.69195 18.31C6.08195 18.7 6.08195 19.33 5.69195 19.72L5.56195 19.85C5.37195 20.04 5.11195 20.14 4.86195 20.14ZM22.002 13H21.922C21.372 13 20.922 12.55 20.922 12C20.922 11.45 21.372 11 21.922 11C22.472 11 22.962 11.45 22.962 12C22.962 12.55 22.552 13 22.002 13ZM2.08195 13H2.00195C1.45195 13 1.00195 12.55 1.00195 12C1.00195 11.45 1.45195 11 2.00195 11C2.55195 11 3.04195 11.45 3.04195 12C3.04195 12.55 2.63195 13 2.08195 13ZM19.012 5.99C18.752 5.99 18.502 5.89 18.302 5.7C17.912 5.31 17.912 4.68 18.302 4.29L18.432 4.16C18.822 3.77 19.452 3.77 19.842 4.16C20.232 4.55 20.232 5.18 19.842 5.57L19.712 5.7C19.522 5.89 19.272 5.99 19.012 5.99ZM4.99195 5.99C4.73195 5.99 4.48195 5.89 4.28195 5.7L4.15195 5.56C3.76195 5.17 3.76195 4.54 4.15195 4.15C4.54195 3.76 5.17195 3.76 5.56195 4.15L5.69195 4.28C6.08195 4.67 6.08195 5.3 5.69195 5.69C5.50195 5.89 5.24195 5.99 4.99195 5.99ZM12.002 3.04C11.452 3.04 11.002 2.63 11.002 2.08V2C11.002 1.45 11.452 1 12.002 1C12.552 1 13.002 1.45 13.002 2C13.002 2.55 12.552 3.04 12.002 3.04Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DarkTheme = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4624 22.7501C12.2924 22.7501 12.1224 22.7501 11.9524 22.7401C6.35239 22.4901 1.67239 17.9801 1.28239 12.4801C0.94239 7.76011 3.67239 3.35011 8.07239 1.50011C9.32239 0.980114 9.98239 1.38011 10.2624 1.67011C10.5424 1.95011 10.9324 2.60011 10.4124 3.79011C9.95239 4.85011 9.72239 5.98011 9.73239 7.14011C9.75239 11.5701 13.4324 15.3301 17.9224 15.5101C18.5724 15.5401 19.2124 15.4901 19.8324 15.3801C21.1524 15.1401 21.7024 15.6701 21.9124 16.0101C22.1224 16.3501 22.3624 17.0801 21.5624 18.1601C19.4424 21.0601 16.0724 22.7501 12.4624 22.7501ZM2.77239 12.3701C3.11239 17.1301 7.17239 21.0301 12.0124 21.2401C15.3024 21.4001 18.4224 19.9001 20.3424 17.2801C20.4924 17.0701 20.5624 16.9201 20.5924 16.8401C20.5024 16.8301 20.3424 16.8201 20.0924 16.8701C19.3624 17.0001 18.6024 17.0501 17.8524 17.0201C12.5724 16.8101 8.25239 12.3801 8.22239 7.16011C8.22239 5.78011 8.49239 4.45011 9.04239 3.20011C9.14239 2.98011 9.16239 2.83011 9.17239 2.75011C9.08239 2.75011 8.92239 2.77011 8.66239 2.88011C4.85239 4.48011 2.49239 8.30011 2.77239 12.3701Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const MenuBar = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3 12H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3 17H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const ChatFill = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15Z"></path>
    </svg>
  );
};
export const UploadCloudFill = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 13H16L12 8L8 13H11V17H13V13Z"></path>
    </svg>
  );
};
export const UploadCloud = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_595_239)">
        <path
          d="M16 16L12 12L8 16"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 12V21"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.39 18.39C21.3653 17.8583 22.1358 17.0169 22.5798 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9434 10.7355 21.0666 10.0534C20.1898 9.37137 19.1108 9.00072 18 8.99998H16.74C16.4373 7.82923 15.8731 6.74232 15.0899 5.82098C14.3067 4.89964 13.3248 4.16783 12.2181 3.68059C11.1113 3.19335 9.90851 2.96334 8.70008 3.00787C7.49164 3.05239 6.30903 3.37028 5.24114 3.93765C4.17325 4.50501 3.24787 5.30709 2.53458 6.28357C1.82129 7.26004 1.33865 8.38552 1.12294 9.57538C0.90723 10.7652 0.964065 11.9885 1.28917 13.1532C1.61428 14.318 2.1992 15.3938 2.99996 16.3"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 16L12 12L8 16"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_595_239">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DotVetical = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-more-vertical"
    >
      <circle cx="12" cy="12" r="1"></circle>
      <circle cx="12" cy="5" r="1"></circle>
      <circle cx="12" cy="19" r="1"></circle>
    </svg>
  );
};
export const SendInvitaions = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 14C20.2348 14 19.9804 14.1054 19.7929 14.2929C19.6054 14.4804 19.5 14.7348 19.5 15V19C19.5 19.2652 19.3946 19.5196 19.2071 19.7071C19.0196 19.8946 18.7652 20 18.5 20H4.5C4.23478 20 3.98043 19.8946 3.79289 19.7071C3.60536 19.5196 3.5 19.2652 3.5 19V9.41L9.38 15.3C9.9425 15.8618 10.705 16.1774 11.5 16.1774C12.295 16.1774 13.0575 15.8618 13.62 15.3L15.26 13.66C15.4483 13.4717 15.5541 13.2163 15.5541 12.95C15.5541 12.6837 15.4483 12.4283 15.26 12.24C15.0717 12.0517 14.8163 11.9459 14.55 11.9459C14.2837 11.9459 14.0283 12.0517 13.84 12.24L12.2 13.88C12.0131 14.0632 11.7618 14.1659 11.5 14.1659C11.2382 14.1659 10.9869 14.0632 10.8 13.88L4.91 8H11.5C11.7652 8 12.0196 7.89465 12.2071 7.70711C12.3946 7.51957 12.5 7.26522 12.5 7C12.5 6.73479 12.3946 6.48043 12.2071 6.2929C12.0196 6.10536 11.7652 6 11.5 6H4.5C3.70435 6 2.94129 6.31607 2.37868 6.87868C1.81607 7.44129 1.5 8.20435 1.5 9V19C1.5 19.7957 1.81607 20.5587 2.37868 21.1213C2.94129 21.6839 3.70435 22 4.5 22H18.5C19.2956 22 20.0587 21.6839 20.6213 21.1213C21.1839 20.5587 21.5 19.7957 21.5 19V15C21.5 14.7348 21.3946 14.4804 21.2071 14.2929C21.0196 14.1054 20.7652 14 20.5 14ZM22.21 5.29L19.21 2.29C19.1149 2.19896 19.0028 2.1276 18.88 2.08C18.6365 1.97999 18.3635 1.97999 18.12 2.08C17.9972 2.1276 17.8851 2.19896 17.79 2.29L14.79 5.29C14.6017 5.47831 14.4959 5.7337 14.4959 6C14.4959 6.2663 14.6017 6.5217 14.79 6.71C14.9783 6.89831 15.2337 7.0041 15.5 7.0041C15.7663 7.0041 16.0217 6.89831 16.21 6.71L17.5 5.41V11C17.5 11.2652 17.6054 11.5196 17.7929 11.7071C17.9804 11.8946 18.2348 12 18.5 12C18.7652 12 19.0196 11.8946 19.2071 11.7071C19.3946 11.5196 19.5 11.2652 19.5 11V5.41L20.79 6.71C20.883 6.80373 20.9936 6.87813 21.1154 6.92889C21.2373 6.97966 21.368 7.0058 21.5 7.0058C21.632 7.0058 21.7627 6.97966 21.8846 6.92889C22.0064 6.87813 22.117 6.80373 22.21 6.71C22.3037 6.61704 22.3781 6.50644 22.4289 6.38458C22.4797 6.26272 22.5058 6.13201 22.5058 6C22.5058 5.86799 22.4797 5.73729 22.4289 5.61543C22.3781 5.49357 22.3037 5.38297 22.21 5.29Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ReciveInvitaions = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 10C20.2348 10 19.9804 9.89464 19.7929 9.7071C19.6054 9.51957 19.5 9.26521 19.5 9V5C19.5 4.73478 19.3946 4.48043 19.2071 4.29289C19.0196 4.10535 18.7652 4 18.5 4H4.5C4.23478 4 3.98043 4.10535 3.79289 4.29289C3.60536 4.48043 3.5 4.73478 3.5 5V14.59L9.38 8.7C9.9425 8.1382 10.705 7.82264 11.5 7.82264C12.295 7.82264 13.0575 8.1382 13.62 8.7L15.26 10.34C15.4483 10.5283 15.5541 10.7837 15.5541 11.05C15.5541 11.3163 15.4483 11.5717 15.26 11.76C15.0717 11.9483 14.8163 12.0541 14.55 12.0541C14.2837 12.0541 14.0283 11.9483 13.84 11.76L12.2 10.12C12.0131 9.93677 11.7618 9.83414 11.5 9.83414C11.2382 9.83414 10.9869 9.93677 10.8 10.12L4.91 16H11.5C11.7652 16 12.0196 16.1054 12.2071 16.2929C12.3946 16.4804 12.5 16.7348 12.5 17C12.5 17.2652 12.3946 17.5196 12.2071 17.7071C12.0196 17.8946 11.7652 18 11.5 18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V5C1.5 4.20435 1.81607 3.44128 2.37868 2.87868C2.94129 2.31607 3.70435 2 4.5 2H18.5C19.2956 2 20.0587 2.31607 20.6213 2.87868C21.1839 3.44128 21.5 4.20435 21.5 5V9C21.5 9.26521 21.3946 9.51957 21.2071 9.7071C21.0196 9.89464 20.7652 10 20.5 10ZM22.21 18.71L19.21 21.71C19.1149 21.801 19.0028 21.8724 18.88 21.92C18.6365 22.02 18.3635 22.02 18.12 21.92C17.9972 21.8724 17.8851 21.801 17.79 21.71L14.79 18.71C14.6017 18.5217 14.4959 18.2663 14.4959 18C14.4959 17.7337 14.6017 17.4783 14.79 17.29C14.9783 17.1017 15.2337 16.9959 15.5 16.9959C15.7663 16.9959 16.0217 17.1017 16.21 17.29L17.5 18.59V13C17.5 12.7348 17.6054 12.4804 17.7929 12.2929C17.9804 12.1054 18.2348 12 18.5 12C18.7652 12 19.0196 12.1054 19.2071 12.2929C19.3946 12.4804 19.5 12.7348 19.5 13V18.59L20.79 17.29C20.883 17.1963 20.9936 17.1219 21.1154 17.0711C21.2373 17.0203 21.368 16.9942 21.5 16.9942C21.632 16.9942 21.7627 17.0203 21.8846 17.0711C22.0064 17.1219 22.117 17.1963 22.21 17.29C22.3037 17.383 22.3781 17.4936 22.4289 17.6154C22.4797 17.7373 22.5058 17.868 22.5058 18C22.5058 18.132 22.4797 18.2627 22.4289 18.3846C22.3781 18.5064 22.3037 18.617 22.21 18.71Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const DocumentIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V5.625C3.75 5.45924 3.81585 5.30027 3.93306 5.18306C4.05027 5.06585 4.20924 5 4.375 5H10.625L13.75 8.125V16.875C13.75 17.0408 13.6842 17.1997 13.5669 17.3169C13.4497 17.4342 13.2908 17.5 13.125 17.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.25 5V3.125C6.25 2.95924 6.31585 2.80027 6.43306 2.68306C6.55027 2.56585 6.70924 2.5 6.875 2.5H13.125L16.25 5.625V14.375C16.25 14.5408 16.1842 14.6997 16.0669 14.8169C15.9497 14.9342 15.7908 15 15.625 15H13.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.875 11.875H10.625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.875 14.375H10.625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ClaimIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 22.7599C10.9099 22.7599 9.8299 22.4399 8.9799 21.8099L4.6799 18.5999C3.5399 17.7499 2.6499 15.9699 2.6499 14.5599V7.11994C2.6499 5.57994 3.7799 3.93994 5.2299 3.39994L10.2199 1.52994C11.2099 1.15994 12.7699 1.15994 13.7599 1.52994L18.7499 3.39994C20.1999 3.93994 21.3299 5.57994 21.3299 7.11994V14.5499C21.3299 15.9699 20.4399 17.7399 19.2999 18.5899L14.9999 21.7999C14.1699 22.4399 13.0899 22.7599 11.9999 22.7599ZM10.7499 2.93994L5.7599 4.80994C4.9099 5.12994 4.1599 6.20994 4.1599 7.12994V14.5599C4.1599 15.5099 4.8299 16.8399 5.5799 17.3999L9.8799 20.6099C11.0299 21.4699 12.9699 21.4699 14.1299 20.6099L18.4299 17.3999C19.1899 16.8299 19.8499 15.5099 19.8499 14.5599V7.11994C19.8499 6.20994 19.0999 5.12994 18.2499 4.79994L13.2599 2.92994C12.5799 2.68994 11.4199 2.68994 10.7499 2.93994Z"
        fill="currentColor"
      />
      <path
        d="M10.6602 14.2301C10.4702 14.2301 10.2802 14.1601 10.1302 14.0101L8.52023 12.4001C8.23023 12.1101 8.23023 11.6301 8.52023 11.3401C8.81023 11.0501 9.29023 11.0501 9.58023 11.3401L10.6602 12.4201L14.4302 8.65012C14.7202 8.36012 15.2002 8.36012 15.4902 8.65012C15.7802 8.94012 15.7802 9.42012 15.4902 9.71012L11.1902 14.0101C11.0402 14.1601 10.8502 14.2301 10.6602 14.2301Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ClaimNewIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14.3328V6.99951C5 6.7343 5.10536 6.47994 5.29289 6.29241C5.48043 6.10487 5.73478 5.99951 6 5.99951H26C26.2652 5.99951 26.5196 6.10487 26.7071 6.29241C26.8946 6.47994 27 6.7343 27 6.99951V14.3328C27 24.8348 18.0868 28.3141 16.307 28.9042C16.1081 28.9726 15.8919 28.9726 15.693 28.9042C13.9133 28.3141 5 24.8348 5 14.3328Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16H20"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 12V20"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // <svg
    //   width={width || fallbackWidth}
    //   height={height || fallbackHeight}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M8 12.2H15"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M8 16.2H12.38"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    // </svg>
  );
};
export const ClaimInprogressIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14.3333V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H26C26.2652 6 26.5196 6.10536 26.7071 6.29289C26.8946 6.48043 27 6.73478 27 7V14.3333C27 24.8352 18.0867 28.3146 16.307 28.9047C16.1081 28.9731 15.8919 28.9731 15.693 28.9047C13.9133 28.3146 5 24.8352 5 14.3333Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 12V17"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 21.5C16.5 21.7761 16.2761 22 16 22C15.7239 22 15.5 21.7761 15.5 21.5C15.5 21.2239 15.7239 21 16 21C16.2761 21 16.5 21.2239 16.5 21.5Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>

    // <svg
    //   width={width || fallbackWidth}
    //   height={height || fallbackHeight}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M8 13H12"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M8 17H16"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    // </svg>
  );
};
export const ClaimUholdIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.1875 3L27.8125 29"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.4419 24.19C20.7458 27.258 17.3354 28.5637 16.307 28.9047C16.1081 28.9731 15.8919 28.9731 15.693 28.9047C13.9133 28.3146 5 24.8352 5 14.3333V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H6.91347"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3164 6H25.9983C26.2635 6 26.5179 6.10536 26.7054 6.29289C26.893 6.48043 26.9983 6.73478 26.9983 7V14.3333C26.9983 16.8438 26.489 18.953 25.6895 20.7173"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // <svg
    //   width={width || fallbackWidth}
    //   height={height || fallbackHeight}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M12 8.5C10.9 8.5 10 9.4 10 10.5C10 11.6 10.9 12.5 12 12.5C13.1 12.5 14 11.6 14 10.5"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M12 12.5V15.5"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M20.5902 7.12006C20.5902 5.89006 19.6502 4.53006 18.5002 4.10006L13.5102 2.23006C12.6802 1.92006 11.3202 1.92006 10.4902 2.23006L5.50016 4.11006C4.35016 4.54006 3.41016 5.90006 3.41016 7.12006V14.5501C3.41016 15.7301 4.19016 17.2801 5.14016 17.9901L9.44016 21.2001C10.8502 22.2601 13.1702 22.2601 14.5802 21.2001L18.8802 17.9901C19.8302 17.2801 20.6102 15.7301 20.6102 14.5501V11.0301"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    // </svg>
  );
};
export const ClaimCompletedIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14.3333V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H26C26.2652 6 26.5196 6.10536 26.7071 6.29289C26.8946 6.48043 27 6.73478 27 7V14.3333C27 24.8352 18.0868 28.3146 16.307 28.9047C16.1081 28.9731 15.8919 28.9731 15.693 28.9047C13.9133 28.3146 5 24.8352 5 14.3333Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.5 13L14.1666 20L10.5 16.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // <svg
    //   width={width || fallbackWidth}
    //   height={height || fallbackHeight}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M9.31006 14.7L10.8101 16.2L14.8101 12.2"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    //   <path
    //     d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
    //     stroke="currentColor"
    //     stroke-width="1.5"
    //     stroke-miterlimit="10"
    //     stroke-linecap="round"
    //     stroke-linejoin="round"
    //   />
    // </svg>
  );
};
export const ClaimTotalIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14.3333V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H26C26.2652 6 26.5196 6.10536 26.7071 6.29289C26.8946 6.48043 27 6.73478 27 7V14.3333C27 24.8352 18.0868 28.3146 16.307 28.9047C16.1081 28.9731 15.8919 28.9731 15.693 28.9047C13.9133 28.3146 5 24.8352 5 14.3333Z"
        stroke="CurrentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // <svg
    //   width={width || fallbackWidth}
    //   height={height || fallbackHeight}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M17.62 9.62012H12.37C11.96 9.62012 11.62 9.28012 11.62 8.87012C11.62 8.46012 11.96 8.12012 12.37 8.12012H17.62C18.03 8.12012 18.37 8.46012 18.37 8.87012C18.37 9.28012 18.04 9.62012 17.62 9.62012Z"
    //     fill="currentColor"
    //   />
    //   <path
    //     d="M7.12006 10.3801C6.93006 10.3801 6.74006 10.3101 6.59006 10.1601L5.84006 9.41007C5.55006 9.12007 5.55006 8.64007 5.84006 8.35007C6.13006 8.06007 6.61006 8.06007 6.90006 8.35007L7.12006 8.57007L8.84006 6.85007C9.13006 6.56007 9.61006 6.56007 9.90006 6.85007C10.1901 7.14007 10.1901 7.62007 9.90006 7.91007L7.65006 10.1601C7.51006 10.3001 7.32006 10.3801 7.12006 10.3801Z"
    //     fill="currentColor"
    //   />
    //   <path
    //     d="M17.62 16.6201H12.37C11.96 16.6201 11.62 16.2801 11.62 15.8701C11.62 15.4601 11.96 15.1201 12.37 15.1201H17.62C18.03 15.1201 18.37 15.4601 18.37 15.8701C18.37 16.2801 18.04 16.6201 17.62 16.6201Z"
    //     fill="currentColor"
    //   />
    //   <path
    //     d="M7.12006 17.3801C6.93006 17.3801 6.74006 17.3101 6.59006 17.1601L5.84006 16.4101C5.55006 16.1201 5.55006 15.6401 5.84006 15.3501C6.13006 15.0601 6.61006 15.0601 6.90006 15.3501L7.12006 15.5701L8.84006 13.8501C9.13006 13.5601 9.61006 13.5601 9.90006 13.8501C10.1901 14.1401 10.1901 14.6201 9.90006 14.9101L7.65006 17.1601C7.51006 17.3001 7.32006 17.3801 7.12006 17.3801Z"
    //     fill="currentColor"
    //   />
    //   <path
    //     d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
    //     fill="currentColor"
    //   />
    // </svg>
  );
};
export const AcceptedIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeclinedIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16998 14.8299L14.83 9.16992M14.83 14.8299L9.16998 9.16992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EyeOutlineIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9998 20.27C15.5298 20.27 18.8198 18.19 21.1098 14.59C22.0098 13.18 22.0098 10.81 21.1098 9.39997C18.8198 5.79997 15.5298 3.71997 11.9998 3.71997C8.46984 3.71997 5.17984 5.79997 2.88984 9.39997C1.98984 10.81 1.98984 13.18 2.88984 14.59C5.17984 18.19 8.46984 20.27 11.9998 20.27Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EyeCloseIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.74294 3.09232C10.1494 3.03223 10.5686 3 11.0004 3C16.1054 3 19.4553 7.50484 20.5807 9.28682C20.7169 9.5025 20.785 9.61034 20.8231 9.77667C20.8518 9.90159 20.8517 10.0987 20.8231 10.2236C20.7849 10.3899 20.7164 10.4985 20.5792 10.7156C20.2793 11.1901 19.8222 11.8571 19.2165 12.5805M5.72432 4.71504C3.56225 6.1817 2.09445 8.21938 1.42111 9.28528C1.28428 9.50187 1.21587 9.61016 1.17774 9.77648C1.1491 9.9014 1.14909 10.0984 1.17771 10.2234C1.21583 10.3897 1.28393 10.4975 1.42013 10.7132C2.54554 12.4952 5.89541 17 11.0004 17C13.0588 17 14.8319 16.2676 16.2888 15.2766M2.00042 1L20.0004 19M8.8791 7.87868C8.3362 8.42157 8.00042 9.17157 8.00042 10C8.00042 11.6569 9.34356 13 11.0004 13C11.8288 13 12.5788 12.6642 13.1217 12.1213"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ReplyIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11 20L1 12L11 4V9C16.5228 9 21 13.4772 21 19C21 19.2729 20.9891 19.5433 20.9676 19.8107C19.4605 16.9502 16.458 15 13 15H11V20Z"></path>
    </svg>
  );
};
export const BackIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12H4M4 12L10 18M4 12L10 6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const StorageIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25002 10C6.25002 8.76387 6.61657 7.5555 7.30333 6.52769C7.99009 5.49988 8.96621 4.6988 10.1082 4.22576C11.2503 3.75271 12.5069 3.62894 13.7193 3.87009C14.9317 4.11125 16.0454 4.70651 16.9194 5.58059C17.7935 6.45466 18.3888 7.56831 18.6299 8.78069C18.8711 9.99307 18.7473 11.2497 18.2743 12.3918C17.8012 13.5338 17.0001 14.5099 15.9723 15.1967C14.9445 15.8834 13.7361 16.25 12.5 16.25H5.62502C5.00458 16.2494 4.39136 16.1168 3.82607 15.8611C3.26078 15.6054 2.75635 15.2324 2.34625 14.7668C1.93615 14.3012 1.62977 13.7537 1.44745 13.1607C1.26512 12.5676 1.21101 11.9426 1.28873 11.327C1.36644 10.7115 1.57418 10.1195 1.89818 9.59037C2.22217 9.06125 2.655 8.60709 3.16794 8.25803C3.68088 7.90898 4.2622 7.67302 4.87331 7.56581C5.48441 7.4586 6.11133 7.4826 6.71246 7.63622"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 9.0625L11.25 12.8125L9.375 10.9375"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EmailIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TimeIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.71 15.1798L12.61 13.3298C12.07 13.0098 11.63 12.2398 11.63 11.6098V7.50977"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const NationalIndentityIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.0216 33.3621H2.97836C1.33609 33.3621 0 32.026 0 30.3837V9.61711C0 7.97477 1.33609 6.63867 2.97836 6.63867H37.0216C38.6638 6.63867 39.9999 7.97477 39.9999 9.61703V30.3837C40 32.026 38.6639 33.3621 37.0216 33.3621Z"
        fill="#ECF0F1"
      />
      <path
        d="M37.0216 6.63867H20V33.3621H37.0216C38.6639 33.3621 40 32.026 40 30.3838V9.61711C40 7.97477 38.6639 6.63867 37.0216 6.63867Z"
        fill="#DBDDE4"
      />
      <path
        d="M19.0637 16.3402H33.702C34.407 16.3402 34.9785 15.7687 34.9785 15.0637C34.9785 14.3587 34.407 13.7871 33.702 13.7871H19.0637C18.3587 13.7871 17.7871 14.3587 17.7871 15.0637C17.7871 15.7687 18.3587 16.3402 19.0637 16.3402Z"
        fill="#C1C4C8"
      />
      <path
        d="M33.702 18.8086H19.0637C18.3587 18.8086 17.7871 19.3802 17.7871 20.0852C17.7871 20.7902 18.3587 21.3617 19.0637 21.3617H33.702C34.407 21.3617 34.9785 20.7902 34.9785 20.0852C34.9786 19.3802 34.407 18.8086 33.702 18.8086Z"
        fill="#C1C4C8"
      />
      <path
        d="M26.3828 23.6592H19.0637C18.3587 23.6592 17.7871 24.2307 17.7871 24.9357C17.7871 25.6407 18.3587 26.2123 19.0637 26.2123H26.3828C27.0878 26.2123 27.6594 25.6407 27.6594 24.9357C27.6595 24.2307 27.0878 23.6592 26.3828 23.6592Z"
        fill="#C1C4C8"
      />
      <path
        d="M12.8513 27.83H6.29805C5.59305 27.83 5.02148 27.2584 5.02148 26.5534V23.2768C5.02148 20.7662 7.06406 18.7236 9.57469 18.7236C12.0853 18.7236 14.1279 20.7662 14.1279 23.2768V26.5534C14.1278 27.2584 13.5563 27.83 12.8513 27.83Z"
        fill="#C1C4C8"
      />
      <path
        d="M9.57469 21.2763C7.06406 21.2763 5.02148 19.2338 5.02148 16.7231C5.02148 14.2125 7.06406 12.1699 9.57469 12.1699C12.0853 12.1699 14.1279 14.2125 14.1279 16.7231C14.1279 19.2338 12.0853 21.2763 9.57469 21.2763Z"
        fill="#C1C4C8"
      />
      <path
        d="M33.7021 13.7871H20V16.3403H33.7021C34.4071 16.3403 34.9787 15.7687 34.9787 15.0637C34.9787 14.3587 34.4071 13.7871 33.7021 13.7871Z"
        fill="#C1C4C8"
      />
      <path
        d="M33.7021 18.8086H20V21.3618H33.7021C34.4071 21.3618 34.9787 20.7902 34.9787 20.0852C34.9787 19.3802 34.4071 18.8086 33.7021 18.8086Z"
        fill="#C1C4C8"
      />
      <path
        d="M26.383 23.6592H20V26.2124H26.383C27.088 26.2124 27.6595 25.6408 27.6595 24.9358C27.6596 24.2307 27.088 23.6592 26.383 23.6592Z"
        fill="#C1C4C8"
      />
    </svg>
  );
};
export const BankVerificationIcon = ({ width, height }) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.7125 35.3996C44.7125 36.0596 44.1612 36.5996 43.4875 36.5996H7.35C6.67625 36.5996 6.125 36.0596 6.125 35.3996V13.7996C6.125 13.1396 6.67625 12.5996 7.35 12.5996H43.4875C44.1612 12.5996 44.7125 13.1396 44.7125 13.7996V35.3996Z"
        fill="#ECF0F1"
      />
      <path
        d="M43.4877 37.2H7.3502C6.30895 37.2 5.5127 36.42 5.5127 35.4V13.8C5.5127 12.78 6.30895 12 7.3502 12H43.4877C44.5289 12 45.3252 12.78 45.3252 13.8V35.4C45.3252 36.42 44.5289 37.2 43.4877 37.2ZM7.3502 13.2C6.9827 13.2 6.7377 13.44 6.7377 13.8V35.4C6.7377 35.76 6.9827 36 7.3502 36H43.4877C43.8552 36 44.1002 35.76 44.1002 35.4V13.8C44.1002 13.44 43.8552 13.2 43.4877 13.2H7.3502Z"
        fill="#C1C4C8"
      />
      <path
        d="M44.7125 22.6202C44.7125 23.0402 44.1612 23.4002 43.4875 23.4002H7.35C6.67625 23.4002 6.125 23.0402 6.125 22.6202V19.4402C6.125 19.0202 6.67625 18.6602 7.35 18.6602H43.4875C44.1612 18.6602 44.7125 19.0202 44.7125 19.4402V22.6202Z"
        fill="#DBDDE4"
      />
      <path
        d="M43.4877 24H7.3502C6.30895 24 5.5127 23.4 5.5127 22.62V19.44C5.5127 18.6 6.30895 18 7.3502 18H43.4877C44.5289 18 45.3252 18.6 45.3252 19.38V22.56C45.3252 23.4 44.5289 24 43.4877 24ZM7.3502 19.2C6.9827 19.2 6.7377 19.38 6.7377 19.44V22.62C6.7377 22.68 6.9827 22.8 7.3502 22.8H43.4877C43.8552 22.8 44.0389 22.68 44.1002 22.56V19.38C44.1002 19.32 43.8552 19.2 43.4877 19.2H7.3502Z"
        fill="#C1C4C8"
      />
      <path d="M22.0498 30H27.5623V31.2H22.0498V30Z" fill="#C1C4C8" />
      <path d="M18.375 33H31.2375V34.2H18.375V33Z" fill="#C1C4C8" />
    </svg>
  );
};
export const DriverlicenseIcon = ({ width, height }) => {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_295_446)">
        <path
          d="M15.0979 10.5167H23.9092C24.796 10.5167 25.5149 9.79769 25.5149 8.91096V7.82452C25.5149 6.9378 24.796 6.21883 23.9092 6.21883H23.4139V5.5398C23.4139 4.86078 22.8627 4.30957 22.1837 4.30957H16.8234C16.1444 4.30957 15.5932 4.86078 15.5932 5.5398V6.21883H15.0979C14.2112 6.21883 13.4922 6.9378 13.4922 7.82452V8.91096C13.4922 9.80568 14.2112 10.5167 15.0979 10.5167Z"
          fill="#DBDDE4"
        />
        <path
          d="M34.5184 8.51172H26.9932V8.91115C26.9932 10.6127 25.6032 12.0027 23.9017 12.0027H15.0983C13.3968 12.0027 12.0068 10.6127 12.0068 8.91115V8.51172H4.48156C2.00512 8.51172 0 10.5168 0 12.9933V30.2086C0 32.685 2.00512 34.6901 4.48156 34.6901H34.5184C36.9949 34.6901 39 32.685 39 30.2086V12.9933C39 10.5248 36.9949 8.51172 34.5184 8.51172ZM11.2239 29.3618C6.94203 29.3618 3.46702 25.8868 3.46702 21.6049C3.46702 17.3231 6.94203 13.8481 11.2239 13.8481C15.5057 13.8481 18.9807 17.3231 18.9807 21.6049C18.9807 25.8868 15.5137 29.3618 11.2239 29.3618ZM34.6223 25.9587H21.5291V24.2891H34.6143V25.9587H34.6223ZM34.6223 22.4357H21.5291V20.7661H34.6143V22.4357H34.6223ZM34.6223 18.9128H21.5291V17.2432H34.6143V18.9128H34.6223Z"
          fill="#ECF0F1"
        />
        <path
          d="M11.2474 15.3418C7.78835 15.3418 4.98438 18.1458 4.98438 21.6048C4.98438 23.0907 5.50363 24.4567 6.36639 25.5272C6.42231 25.0239 6.638 24.4487 7.27708 24.2889C8.50732 23.9774 9.50588 23.2744 9.50588 23.2744L10.4326 26.1982L10.5604 26.5976L10.9758 25.4233C9.93726 23.9774 11.2474 24.0333 11.2474 24.0333C11.2474 24.0333 12.5575 23.9774 11.519 25.4233L11.9264 26.5896L12.0542 26.1982V26.2062L12.198 25.7429L12.9729 23.2824C12.9729 23.2824 13.9715 23.9854 15.2017 24.2969C15.8408 24.4567 16.0565 25.0319 16.1124 25.5352C16.9752 24.4647 17.4944 23.0987 17.4944 21.6128C17.5104 18.1458 14.7064 15.3418 11.2474 15.3418ZM13.7238 20.8699C13.5641 21.445 13.4043 21.6128 13.2924 21.6208C13.1886 22.3078 12.6374 23.1785 11.7826 23.4901C11.4231 23.6179 11.0317 23.6179 10.6722 23.4901C9.80146 23.1785 9.26623 22.3078 9.16238 21.6208C9.05054 21.6128 8.89077 21.453 8.731 20.8699C8.50732 20.079 8.74697 19.9592 8.94669 19.9831C8.90674 19.8713 8.88278 19.7674 8.85881 19.6556C8.78691 19.2881 8.77094 18.9446 8.85082 18.6091C8.95467 18.1697 9.19433 17.8182 9.45795 17.5386C9.62571 17.3629 9.81743 17.2031 10.0171 17.0753C10.1849 16.9635 10.3686 16.8596 10.5604 16.7957C10.7201 16.7398 10.8799 16.7078 11.0557 16.6998C11.5989 16.6519 12.0063 16.7877 12.3019 16.9635C12.7412 17.2031 12.909 17.5307 12.909 17.5307C12.909 17.5307 13.9156 17.6026 13.58 19.6556C13.5641 19.7595 13.5321 19.8713 13.4922 19.9831C13.7078 19.9672 13.9475 20.079 13.7238 20.8699Z"
          fill="#C1C4C8"
        />
      </g>
      <defs>
        <clipPath id="clip0_295_446">
          <rect width="39" height="39" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PassportIcon = ({ width, height }) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_295_469)">
        <path
          d="M4.03125 3.20859C4.03125 2.78723 4.11424 2.37 4.27549 1.98071C4.43673 1.59143 4.67308 1.23772 4.97102 0.939772C5.26897 0.641827 5.62268 0.405485 6.01196 0.244238C6.40125 0.0829917 6.81848 -4.95632e-07 7.23984 0L27.7574 0C28.1788 -2.97423e-06 28.596 0.0829875 28.9853 0.244233C29.3746 0.405479 29.7283 0.641821 30.0263 0.939767C30.3242 1.23771 30.5606 1.59143 30.7218 1.98071C30.883 2.37 30.966 2.78723 30.966 3.20859V31.6456C30.966 32.0669 30.883 32.4841 30.7218 32.8734C30.5606 33.2627 30.3242 33.6164 30.0263 33.9144C29.7283 34.2123 29.3746 34.4487 28.9853 34.6099C28.596 34.7712 28.1788 34.8541 27.7574 34.8541H7.23984C6.81848 34.8541 6.40125 34.7712 6.01196 34.6099C5.62268 34.4487 5.26896 34.2123 4.97102 33.9144C4.67307 33.6164 4.43673 33.2627 4.27548 32.8734C4.11424 32.4841 4.03125 32.0669 4.03125 31.6456L4.03125 3.20859Z"
          fill="#ECF0F1"
        />
        <path
          d="M15.3925 31.8891C15.2677 31.8891 15.148 31.8395 15.0597 31.7513C14.9715 31.663 14.9219 31.5433 14.9219 31.4185V28.9569C14.9219 28.8951 14.934 28.8339 14.9577 28.7768C14.9813 28.7197 15.016 28.6679 15.0597 28.6242C15.1034 28.5805 15.1553 28.5458 15.2124 28.5221C15.2695 28.4985 15.3307 28.4863 15.3925 28.4863H19.5563C19.6181 28.4863 19.6792 28.4985 19.7363 28.5221C19.7934 28.5458 19.8453 28.5805 19.889 28.6242C19.9327 28.6679 19.9674 28.7197 19.991 28.7768C20.0147 28.8339 20.0268 28.8951 20.0268 28.9569V31.4185C20.0268 31.5433 19.9773 31.663 19.889 31.7513C19.8008 31.8395 19.6811 31.8891 19.5563 31.8891H15.3925Z"
          fill="#C1C4C8"
        />
        <path
          d="M20.0268 29.9746V30.3574H14.9219V29.9746H20.0268Z"
          fill="#DBDDE4"
        />
        <path
          d="M18.2554 30.1668C18.2541 30.3209 18.2073 30.4712 18.1208 30.5987C18.0342 30.7262 17.9119 30.8253 17.7692 30.8834C17.6264 30.9415 17.4697 30.956 17.3187 30.9252C17.1677 30.8943 17.0292 30.8195 16.9207 30.7101C16.8122 30.6007 16.7385 30.4616 16.7089 30.3104C16.6793 30.1591 16.6951 30.0025 16.7544 29.8603C16.8136 29.718 16.9137 29.5965 17.0419 29.511C17.1701 29.4255 17.3208 29.3799 17.4749 29.3799C17.6827 29.3807 17.8817 29.4641 18.0281 29.6117C18.1745 29.7593 18.2562 29.9589 18.2554 30.1668Z"
          fill="#DBDDE4"
        />
        <path
          d="M21.607 17.4622C21.607 18.2823 21.3638 19.084 20.9081 19.766C20.4525 20.4479 19.8048 20.9794 19.0471 21.2933C18.2894 21.6071 17.4556 21.6892 16.6512 21.5292C15.8468 21.3692 15.108 20.9743 14.528 20.3944C13.9481 19.8144 13.5532 19.0755 13.3932 18.2712C13.2332 17.4668 13.3153 16.633 13.6291 15.8753C13.943 15.1176 14.4745 14.4699 15.1564 14.0143C15.8383 13.5586 16.6401 13.3154 17.4602 13.3154C18.56 13.3154 19.6147 13.7523 20.3924 14.53C21.1701 15.3076 21.607 16.3624 21.607 17.4622Z"
          fill="#C1C4C8"
        />
        <path
          d="M9.84615 7.22496H10.0484C10.2724 7.22496 10.3844 7.12747 10.3844 6.9325C10.3844 6.73752 10.2724 6.64003 10.0484 6.64002H9.84615V7.22496ZM9.84615 8.49439H9.23633V6.14842H10.2071C10.3163 6.14088 10.4259 6.15516 10.5295 6.19041C10.6331 6.22567 10.7287 6.2812 10.8107 6.35377C10.8839 6.43044 10.9405 6.52142 10.9769 6.62102C11.0133 6.72061 11.0288 6.82665 11.0222 6.93249C11.0288 7.03832 11.0133 7.14436 10.9769 7.24395C10.9405 7.34354 10.8839 7.43453 10.8107 7.5112C10.7287 7.58377 10.6332 7.6393 10.5295 7.67456C10.4259 7.70981 10.3163 7.72409 10.2071 7.71655H9.84618L9.84615 8.49439ZM12.49 7.62321L12.2162 6.84226L11.9424 7.62322L12.49 7.62321ZM12.6518 8.0868H11.7806L11.6406 8.49439H10.9903L11.8833 6.14842H12.5491L13.4421 8.49439H12.7918L12.6518 8.0868ZM14.997 6.74892C14.9375 6.69901 14.8702 6.65908 14.7979 6.63069C14.7368 6.60482 14.6713 6.59108 14.605 6.59024C14.5363 6.58721 14.4685 6.6069 14.4121 6.64625C14.3886 6.66262 14.3695 6.68453 14.3565 6.71003C14.3435 6.73553 14.3369 6.76385 14.3374 6.79248C14.3361 6.83025 14.3494 6.86708 14.3748 6.89515C14.4026 6.92432 14.4352 6.94853 14.4712 6.96671C14.5156 6.98645 14.5614 7.00308 14.6081 7.0165C14.66 7.03101 14.7108 7.04656 14.7606 7.06316C14.9281 7.10955 15.0791 7.20231 15.1962 7.33074C15.2937 7.45315 15.3435 7.60685 15.3362 7.76322C15.3378 7.87521 15.3166 7.98635 15.2739 8.08991C15.2351 8.18652 15.1744 8.2728 15.0966 8.34193C15.0132 8.4141 14.9157 8.46813 14.8104 8.50061C14.687 8.54181 14.5576 8.5618 14.4276 8.55972C14.1319 8.56001 13.8435 8.46751 13.6031 8.29526L13.8645 7.80366C13.9449 7.87738 14.0362 7.93825 14.1352 7.98412C14.2182 8.02217 14.3083 8.04231 14.3996 8.04323C14.4793 8.04979 14.5585 8.02527 14.6205 7.97478C14.6435 7.95577 14.662 7.93202 14.6749 7.90517C14.6878 7.87832 14.6947 7.84899 14.6952 7.81921C14.6961 7.7881 14.6897 7.7572 14.6765 7.72899C14.6624 7.7001 14.641 7.67542 14.6143 7.65744C14.5791 7.63126 14.5404 7.6103 14.4992 7.59521C14.4536 7.57654 14.3976 7.5558 14.3312 7.53298C14.2524 7.5081 14.1746 7.48113 14.0978 7.45208C14.0248 7.42193 13.9566 7.38103 13.8956 7.33075C13.8358 7.27877 13.7871 7.21528 13.7525 7.14406C13.7144 7.0525 13.6963 6.95383 13.6996 6.85471C13.698 6.74734 13.717 6.64067 13.7556 6.54046C13.7922 6.44926 13.8473 6.36663 13.9174 6.29778C13.9905 6.22772 14.0773 6.17368 14.1725 6.1391C14.2813 6.10054 14.3962 6.08158 14.5116 6.08309C14.6346 6.08401 14.757 6.10074 14.8757 6.13287C15.0024 6.16407 15.1247 6.21111 15.2397 6.27288L14.997 6.74892ZM17.0084 6.74892C16.9489 6.699 16.8816 6.65906 16.8093 6.63069C16.7482 6.60481 16.6827 6.59108 16.6164 6.59024C16.5477 6.58721 16.4799 6.6069 16.4235 6.64625C16.4 6.66262 16.3809 6.68453 16.3679 6.71003C16.3549 6.73553 16.3483 6.76385 16.3489 6.79248C16.3475 6.83025 16.3609 6.86708 16.3862 6.89515C16.414 6.92432 16.4466 6.94853 16.4826 6.96671C16.5271 6.98645 16.5728 7.00309 16.6196 7.0165C16.6714 7.03101 16.7222 7.04656 16.772 7.06316C16.9395 7.10952 17.0905 7.20228 17.2076 7.33074C17.3052 7.45314 17.355 7.60684 17.3476 7.76322C17.3492 7.87521 17.3281 7.98635 17.2854 8.08991C17.2466 8.18652 17.1859 8.2728 17.108 8.34193C17.0247 8.41409 16.9272 8.46812 16.8218 8.50061C16.6985 8.54182 16.5691 8.5618 16.4391 8.55972C16.1433 8.56001 15.855 8.46751 15.6146 8.29526L15.8759 7.80367C15.9563 7.87739 16.0476 7.93825 16.1466 7.98412C16.2297 8.02217 16.3198 8.04231 16.4111 8.04323C16.4908 8.04981 16.5699 8.02528 16.632 7.97479C16.6549 7.95579 16.6735 7.93204 16.6864 7.90519C16.6993 7.87833 16.7062 7.84901 16.7067 7.81922C16.7076 7.7881 16.7012 7.7572 16.688 7.729C16.6739 7.70011 16.6524 7.67543 16.6258 7.65744C16.5906 7.63127 16.5518 7.61031 16.5107 7.59522C16.465 7.57655 16.409 7.55581 16.3426 7.53299C16.2638 7.5081 16.186 7.48114 16.1093 7.45209C16.0362 7.42194 15.968 7.38104 15.907 7.33076C15.8473 7.27878 15.7986 7.21528 15.7639 7.14407C15.7258 7.05251 15.7078 6.95384 15.711 6.85472C15.7094 6.74735 15.7284 6.64068 15.767 6.54047C15.8036 6.44927 15.8587 6.36664 15.9288 6.29779C16.0019 6.22773 16.0888 6.17369 16.184 6.13911C16.2928 6.10055 16.4076 6.08159 16.5231 6.0831C16.6461 6.08402 16.7684 6.10075 16.8872 6.13288C17.0139 6.16409 17.1362 6.21113 17.2512 6.27289L17.0084 6.74892ZM18.3416 7.22496H18.5439C18.7679 7.22496 18.8799 7.12747 18.8799 6.9325C18.8799 6.73752 18.7679 6.64003 18.5439 6.64002H18.3416V7.22496ZM18.3416 8.49439H17.7318V6.14842H18.7025C18.8117 6.14087 18.9213 6.15515 19.0249 6.1904C19.1286 6.22566 19.2241 6.28119 19.3061 6.35377C19.3793 6.43043 19.436 6.52142 19.4724 6.62101C19.5088 6.7206 19.5242 6.82665 19.5177 6.93249C19.5242 7.03832 19.5088 7.14436 19.4724 7.24395C19.436 7.34354 19.3793 7.43453 19.3061 7.51119C19.2241 7.58377 19.1286 7.6393 19.0249 7.67456C18.9213 7.70981 18.8117 7.72408 18.7025 7.71654H18.3416L18.3416 8.49439ZM20.3725 7.32141C20.3716 7.41027 20.3896 7.49832 20.4254 7.57965C20.4594 7.6567 20.508 7.72644 20.5685 7.785C20.6289 7.84322 20.6996 7.88966 20.777 7.9219C20.8584 7.95312 20.9449 7.96894 21.0321 7.96857C21.1183 7.96912 21.2038 7.95329 21.2841 7.9219C21.3627 7.89018 21.4346 7.84371 21.4957 7.785C21.5592 7.72562 21.6098 7.65383 21.6444 7.57408C21.679 7.49434 21.6969 7.40834 21.6969 7.32141C21.6969 7.23448 21.679 7.14848 21.6444 7.06874C21.6098 6.98899 21.5592 6.9172 21.4957 6.85782C21.435 6.79937 21.363 6.75385 21.2841 6.72403C21.2043 6.69064 21.1186 6.67371 21.0321 6.67424C20.9446 6.6739 20.858 6.69082 20.777 6.72403C20.6993 6.75438 20.6285 6.79985 20.5685 6.85782C20.508 6.91638 20.4594 6.98612 20.4254 7.06317C20.3896 7.14451 20.3716 7.23255 20.3725 7.32141ZM19.7347 7.32141C19.7312 7.07503 19.8032 6.83347 19.9412 6.62931C20.0791 6.42514 20.2764 6.26816 20.5063 6.17954C20.844 6.05093 21.2172 6.05093 21.5548 6.17954C21.7082 6.23768 21.8479 6.32663 21.9655 6.44089C22.0816 6.55285 22.1738 6.6873 22.2362 6.83604C22.3013 6.98949 22.3342 7.15471 22.3327 7.32141C22.334 7.48909 22.3012 7.65529 22.2362 7.80989C22.1732 7.9574 22.0811 8.09072 21.9655 8.20192C21.8475 8.31646 21.7079 8.40637 21.5548 8.46639C21.2164 8.59084 20.8447 8.59084 20.5063 8.46639C20.3544 8.40584 20.2159 8.31597 20.0987 8.20192C19.9847 8.09002 19.8938 7.95682 19.8311 7.80989C19.7662 7.65528 19.7334 7.48909 19.7347 7.32141ZM23.3277 7.19696H23.4428C23.5408 7.20333 23.6382 7.17707 23.7198 7.12228C23.7501 7.09533 23.7743 7.06227 23.791 7.02527C23.8076 6.98826 23.8162 6.94816 23.8162 6.9076C23.8162 6.86704 23.8076 6.82694 23.791 6.78994C23.7743 6.75293 23.7501 6.71987 23.7198 6.69292C23.6382 6.63814 23.5408 6.61188 23.4428 6.61825H23.3277V7.19696ZM24.6687 8.49439H23.9095L23.3277 7.5921V8.49439H22.7178V6.14842H23.6668C23.7836 6.14595 23.8998 6.16602 24.009 6.20753C24.0972 6.2398 24.1773 6.29109 24.2434 6.35777C24.3095 6.42445 24.3602 6.50489 24.3917 6.59335C24.4254 6.68286 24.4422 6.77777 24.4415 6.87338C24.4485 7.02918 24.4025 7.18275 24.3109 7.30899C24.2145 7.42582 24.0801 7.5051 23.9313 7.533L24.6687 8.49439ZM25.8166 6.66491V8.49439H25.2068V6.66491H24.7059V6.14842H26.3176V6.6649L25.8166 6.66491Z"
          fill="#C1C4C8"
        />
        <path d="M6.94824 0H7.38581V35H6.94824V0Z" fill="#C1C4C8" />
      </g>
      <defs>
        <clipPath id="clip0_295_469">
          <rect width="35" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TickCircleIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CaptureIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9C3.26522 9 3.51957 8.89464 3.70711 8.70711C3.89464 8.51957 4 8.26522 4 8V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8C8.26522 4 8.51957 3.89464 8.70711 3.70711C8.89464 3.51957 9 3.26522 9 3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V8C2 8.26522 2.10536 8.51957 2.29289 8.70711C2.48043 8.89464 2.73478 9 3 9ZM8 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V16C4 15.7348 3.89464 15.4804 3.70711 15.2929C3.51957 15.1054 3.26522 15 3 15C2.73478 15 2.48043 15.1054 2.29289 15.2929C2.10536 15.4804 2 15.7348 2 16V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H8C8.26522 22 8.51957 21.8946 8.70711 21.7071C8.89464 21.5196 9 21.2652 9 21C9 20.7348 8.89464 20.4804 8.70711 20.2929C8.51957 20.1054 8.26522 20 8 20ZM12 8C11.2089 8 10.4355 8.2346 9.77772 8.67412C9.11992 9.11365 8.60723 9.73836 8.30448 10.4693C8.00173 11.2002 7.92252 12.0044 8.07686 12.7804C8.2312 13.5563 8.61216 14.269 9.17157 14.8284C9.73098 15.3878 10.4437 15.7688 11.2196 15.9231C11.9956 16.0775 12.7998 15.9983 13.5307 15.6955C14.2616 15.3928 14.8864 14.8801 15.3259 14.2223C15.7654 13.5645 16 12.7911 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8ZM12 14C11.6044 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3036 13.1308 10.1522 12.7654C10.0009 12.3999 9.96126 11.9978 10.0384 11.6098C10.1156 11.2219 10.3061 10.8655 10.5858 10.5858C10.8655 10.3061 11.2219 10.1156 11.6098 10.0384C11.9978 9.96126 12.3999 10.0009 12.7654 10.1522C13.1308 10.3036 13.4432 10.56 13.6629 10.8889C13.8827 11.2178 14 11.6044 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14ZM19 2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3C15 3.26522 15.1054 3.51957 15.2929 3.70711C15.4804 3.89464 15.7348 4 16 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V8C20 8.26522 20.1054 8.51957 20.2929 8.70711C20.4804 8.89464 20.7348 9 21 9C21.2652 9 21.5196 8.89464 21.7071 8.70711C21.8946 8.51957 22 8.26522 22 8V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM21 15C20.7348 15 20.4804 15.1054 20.2929 15.2929C20.1054 15.4804 20 15.7348 20 16V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H16C15.7348 20 15.4804 20.1054 15.2929 20.2929C15.1054 20.4804 15 20.7348 15 21C15 21.2652 15.1054 21.5196 15.2929 21.7071C15.4804 21.8946 15.7348 22 16 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V16C22 15.7348 21.8946 15.4804 21.7071 15.2929C21.5196 15.1054 21.2652 15 21 15Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UserFill = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"></path>
    </svg>
  );
};
export const AddItem = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12.75V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H11.25V8C11.25 7.58579 11.5858 7.25 12 7.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RemoveItem = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const EditIcon2 = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.26 3.59997L5.04997 12.29C4.73997 12.62 4.43997 13.27 4.37997 13.72L4.00997 16.96C3.87997 18.13 4.71997 18.93 5.87997 18.73L9.09997 18.18C9.54997 18.1 10.18 17.77 10.49 17.43L18.7 8.73997C20.12 7.23997 20.76 5.52997 18.55 3.43997C16.35 1.36997 14.68 2.09997 13.26 3.59997Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.89 5.05005C12.32 7.81005 14.56 9.92005 17.34 10.2"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 22H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CrossRectengalIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LogoutIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.47458 2.71526C8.16252 1.58997 10.3797 2.62162 10.7085 4.51637H14C15.5188 4.51637 16.75 5.74759 16.75 7.26637C16.75 7.68058 16.4142 8.01637 16 8.01637C15.5858 8.01637 15.25 7.68058 15.25 7.26637C15.25 6.57601 14.6904 6.01637 14 6.01637H10.75V18.5164H14C14.6904 18.5164 15.25 17.9567 15.25 17.2664C15.25 16.8522 15.5858 16.5164 16 16.5164C16.4142 16.5164 16.75 16.8522 16.75 17.2664C16.75 18.7852 15.5188 20.0164 14 20.0164H10.7085C10.3797 21.9111 8.16252 22.9428 6.47458 21.8175L4.47457 20.4841C3.70953 19.9741 3.25 19.1155 3.25 18.196V6.33674C3.25 5.41727 3.70953 4.55863 4.47457 4.0486L6.47458 2.71526ZM15.5302 9.73603C15.8231 10.0289 15.8231 10.5038 15.5302 10.7967L14.8105 11.5164L19.9998 11.5164C20.4141 11.5164 20.7499 11.8521 20.7499 12.2664C20.7499 12.6806 20.4141 13.0164 19.9998 13.0164L14.8105 13.0164L15.5302 13.736C15.8231 14.0289 15.8231 14.5038 15.5302 14.7967C15.2373 15.0896 14.7624 15.0896 14.4695 14.7967L13.1766 13.5038C12.4932 12.8204 12.4932 11.7123 13.1766 11.0289L14.4695 9.73603C14.7624 9.44313 15.2373 9.44313 15.5302 9.73603Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const BackCircleIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.002 22C17.5248 22 22.002 17.5228 22.002 12C22.002 6.47715 17.5248 2 12.002 2C6.47911 2 2.00195 6.47715 2.00195 12C2.00195 17.5228 6.47911 22 12.002 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M15.502 12H9.50195"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.502 9L8.50195 12L11.502 15"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
export const AgentAgencyIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C14.0711 15 15.75 13.3211 15.75 11.25C15.75 9.17893 14.0711 7.5 12 7.5C9.92893 7.5 8.25 9.17893 8.25 11.25C8.25 13.3211 9.92893 15 12 15Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.41724 20.25C5.7575 18.7586 6.5941 17.427 7.79002 16.4732C8.98594 15.5194 10.4703 15 12 15C13.5297 15 15.014 15.5194 16.2099 16.4732C17.4058 17.427 18.2424 18.7586 18.5827 20.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CarrierIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 21.5833V4.33329C6.25 3.82496 6.45193 3.33745 6.81138 2.978C7.17082 2.61856 7.65834 2.41663 8.16667 2.41663H15.8333C16.3417 2.41663 16.8292 2.61856 17.1886 2.978C17.5481 3.33745 17.75 3.82496 17.75 4.33329V21.5833H6.25Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.25001 12H4.33334C3.82501 12 3.3375 12.2019 2.97805 12.5614C2.61861 12.9208 2.41667 13.4083 2.41667 13.9167V19.6667C2.41667 20.175 2.61861 20.6625 2.97805 21.022C3.3375 21.3814 3.82501 21.5833 4.33334 21.5833H6.25001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.75 9.125H19.6667C20.175 9.125 20.6625 9.32693 21.022 9.68638C21.3814 10.0458 21.5833 10.5333 21.5833 11.0417V19.6667C21.5833 20.175 21.3814 20.6625 21.022 21.022C20.6625 21.3814 20.175 21.5833 19.6667 21.5833H17.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0833 6.25H13.9167"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0833 10.0834H13.9167"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0833 13.9166H13.9167"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0833 17.75H13.9167"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const GalleryIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 15.7499L7.71966 11.0302C7.7893 10.9606 7.87198 10.9053 7.96297 10.8676C8.05397 10.8299 8.15149 10.8105 8.24999 10.8105C8.34848 10.8105 8.44601 10.8299 8.537 10.8676C8.62799 10.9053 8.71067 10.9606 8.78032 11.0302L12.9697 15.2196C13.0393 15.2892 13.122 15.3444 13.213 15.3821C13.304 15.4198 13.4015 15.4392 13.5 15.4392C13.5985 15.4392 13.696 15.4198 13.787 15.3821C13.878 15.3444 13.9607 15.2892 14.0303 15.2196L15.9697 13.2802C16.0393 13.2106 16.122 13.1553 16.213 13.1176C16.304 13.0799 16.4015 13.0605 16.5 13.0605C16.5985 13.0605 16.696 13.0799 16.787 13.1176C16.878 13.1553 16.9607 13.2106 17.0303 13.2802L21 17.2499"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.625 10.5C15.2463 10.5 15.75 9.99632 15.75 9.375C15.75 8.75368 15.2463 8.25 14.625 8.25C14.0037 8.25 13.5 8.75368 13.5 9.375C13.5 9.99632 14.0037 10.5 14.625 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const NotesIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15H9V12L18 3L21 6L12 15Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 5.25L18.75 8.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.25 11.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75H12.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const InfoStorkIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M0.0632324 23.9375V0.0625H23.9382V23.9375H0.0632324Z"
        stroke="currentColor"
        stroke-width="0.125"
      />
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 11.25H12.0001L12 16.5H12.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8125 8.8125C12.3303 8.8125 12.75 8.39277 12.75 7.875C12.75 7.35723 12.3303 6.9375 11.8125 6.9375C11.2947 6.9375 10.875 7.35723 10.875 7.875C10.875 8.39277 11.2947 8.8125 11.8125 8.8125Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CopyIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2507 17.2491V3.74902H6.75"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2505 6.75H3.75V20.25H17.2505V6.75Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LockIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM10.1 17.5H13.9C14.4601 17.5 14.7401 17.5 14.954 17.391C15.1422 17.2951 15.2951 17.1422 15.391 16.954C15.5 16.7401 15.5 16.4601 15.5 15.9V15.1C15.5 14.5399 15.5 14.2599 15.391 14.046C15.2951 13.8578 15.1422 13.7049 14.954 13.609C14.7401 13.5 14.4601 13.5 13.9 13.5H10.1C9.53995 13.5 9.25992 13.5 9.04601 13.609C8.85785 13.7049 8.70487 13.8578 8.60899 14.046C8.5 14.2599 8.5 14.5399 8.5 15.1V15.9C8.5 16.4601 8.5 16.7401 8.60899 16.954C8.70487 17.1422 8.85785 17.2951 9.04601 17.391C9.25992 17.5 9.53995 17.5 10.1 17.5ZM13.75 13.5V11.75C13.75 10.7835 12.9665 10 12 10C11.0335 10 10.25 10.7835 10.25 11.75V13.5H13.75Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FolderIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FolderFillIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.002 11.0699V16.6499C22.002 19.5999 19.602 21.9999 16.652 21.9999H7.35195C4.40195 21.9999 2.00195 19.5999 2.00195 16.6499V9.43994H21.742C21.892 9.88994 21.972 10.3499 21.992 10.8399C22.002 10.9099 22.002 10.9999 22.002 11.0699Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M21.742 9.44H2.00195V6.42C2.00195 3.98 3.98195 2 6.42195 2H8.75195C10.382 2 10.892 2.53 11.542 3.4L12.942 5.26C13.252 5.67 13.292 5.73 13.872 5.73H16.662C19.032 5.72 21.052 7.28 21.742 9.44Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ConfigureIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ClearIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3904_1764)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.876953 7.87695C0.876953 6.02044 1.61445 4.23996 2.92721 2.92721C4.23996 1.61445 6.02044 0.876953 7.87695 0.876953C9.73347 0.876953 11.5139 1.61445 12.8267 2.92721C14.1395 4.23996 14.877 6.02044 14.877 7.87695C14.877 9.73347 14.1395 11.5139 12.8267 12.8267C11.5139 14.1395 9.73347 14.877 7.87695 14.877C6.02044 14.877 4.23996 14.1395 2.92721 12.8267C1.61445 11.5139 0.876953 9.73347 0.876953 7.87695ZM7.87695 1.88103C6.28674 1.88103 4.76165 2.51274 3.63719 3.63719C2.51274 4.76165 1.88103 6.28674 1.88103 7.87695C1.88103 9.46717 2.51274 10.9923 3.63719 12.1167C4.76165 13.2412 6.28674 13.8729 7.87695 13.8729C9.46717 13.8729 10.9923 13.2412 12.1167 12.1167C13.2412 10.9923 13.8729 9.46717 13.8729 7.87695C13.8729 6.28674 13.2412 4.76165 12.1167 3.63719C10.9923 2.51274 9.46717 1.88103 7.87695 1.88103ZM10.3649 5.39001C10.464 5.48911 10.5197 5.62351 10.5197 5.76364C10.5197 5.90377 10.464 6.03816 10.3649 6.13726L8.6242 7.87695L10.3649 9.61665C10.4642 9.71588 10.5199 9.85046 10.5199 9.9908C10.5199 10.1311 10.4642 10.2657 10.3649 10.3649C10.2657 10.4642 10.1311 10.5199 9.9908 10.5199C9.85046 10.5199 9.71588 10.4642 9.61665 10.3649L7.87695 8.6242L6.13726 10.3649C6.08812 10.4141 6.02979 10.4531 5.9656 10.4797C5.9014 10.5062 5.83259 10.5199 5.76311 10.5199C5.69362 10.5199 5.62482 10.5062 5.56062 10.4797C5.49642 10.4531 5.43809 10.4141 5.38896 10.3649C5.33982 10.3158 5.30085 10.2575 5.27426 10.1933C5.24766 10.1291 5.23398 10.0603 5.23398 9.9908C5.23398 9.92131 5.24766 9.85251 5.27426 9.78831C5.30085 9.72411 5.33982 9.66578 5.38896 9.61665L7.12971 7.87695L5.38896 6.13726C5.28973 6.03803 5.23398 5.90344 5.23398 5.76311C5.23398 5.62277 5.28973 5.48819 5.38896 5.38896C5.48819 5.28973 5.62277 5.23398 5.76311 5.23398C5.90344 5.23398 6.03803 5.28973 6.13726 5.38896L7.87695 7.12971L9.61665 5.38896C9.66574 5.33974 9.72405 5.3007 9.78826 5.27406C9.85246 5.24741 9.92129 5.2337 9.9908 5.2337C10.0603 5.2337 10.1291 5.24741 10.1933 5.27406C10.2575 5.3007 10.3159 5.3408 10.3649 5.39001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3904_1764">
          <rect width="15" height="15" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ApplyIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3904_1754)">
        <path
          d="M4 7.5L7 10L11 5M7.5 14.5C6.58075 14.5 5.6705 14.3189 4.82122 13.9672C3.97194 13.6154 3.20026 13.0998 2.55025 12.4497C1.90024 11.7997 1.38463 11.0281 1.03284 10.1788C0.68106 9.32951 0.5 8.41925 0.5 7.5C0.5 6.58075 0.68106 5.6705 1.03284 4.82122C1.38463 3.97194 1.90024 3.20026 2.55025 2.55025C3.20026 1.90024 3.97194 1.38463 4.82122 1.03284C5.6705 0.68106 6.58075 0.5 7.5 0.5C9.35652 0.5 11.137 1.2375 12.4497 2.55025C13.7625 3.86301 14.5 5.64348 14.5 7.5C14.5 9.35652 13.7625 11.137 12.4497 12.4497C11.137 13.7625 9.35652 14.5 7.5 14.5Z"
          stroke="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3904_1754">
          <rect width="15" height="15" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ApiIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.6 20.75C5.21 20.75 3.25 18.79 3.25 14.4V9.6C3.25 5.21 5.21 3.25 9.6 3.25H14.4C18.79 3.25 20.75 5.21 20.75 9.6C20.75 10.01 20.41 10.35 20 10.35C19.59 10.35 19.25 10.01 19.25 9.6C19.25 6.02 17.98 4.75 14.4 4.75H9.6C6.02 4.75 4.75 6.02 4.75 9.6V14.4C4.75 17.98 6.02 19.25 9.6 19.25C10.01 19.25 10.35 19.59 10.35 20C10.35 20.41 10.01 20.75 9.6 20.75Z"
        fill="currentColor"
      />
      <path
        d="M7.98999 17.1C7.82999 17.1 7.65999 17.05 7.51999 16.94C6.64999 16.25 6.23999 15.15 6.23999 13.5V10.5C6.23999 7.6 7.58999 6.25 10.49 6.25H13.49C15.14 6.25 16.23 6.66 16.93 7.53C17.19 7.85 17.13 8.33 16.81 8.58C16.49 8.84 16.01 8.79 15.76 8.46C15.52 8.15 15.02 7.75 13.5 7.75H10.5C8.41999 7.75 7.74999 8.42 7.74999 10.5V13.5C7.74999 15.02 8.15999 15.52 8.45999 15.76C8.77999 16.02 8.83999 16.49 8.57999 16.81C8.42999 17 8.20999 17.1 7.98999 17.1Z"
        fill="currentColor"
      />
      <path
        d="M8.01001 4.75C7.59001 4.75 7.26001 4.41 7.26001 4V2C7.26001 1.59 7.60001 1.25 8.01001 1.25C8.42001 1.25 8.76001 1.59 8.76001 2V4C8.76001 4.41 8.42001 4.75 8.01001 4.75Z"
        fill="currentColor"
      />
      <path
        d="M12 4.75C11.59 4.75 11.25 4.41 11.25 4V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V4C12.75 4.41 12.41 4.75 12 4.75Z"
        fill="currentColor"
      />
      <path
        d="M16 4.75C15.59 4.75 15.25 4.41 15.25 4V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V4C16.75 4.41 16.41 4.75 16 4.75Z"
        fill="currentColor"
      />
      <path
        d="M22 8.75H20C19.59 8.75 19.25 8.41 19.25 8C19.25 7.59 19.59 7.25 20 7.25H22C22.41 7.25 22.75 7.59 22.75 8C22.75 8.41 22.42 8.75 22 8.75Z"
        fill="currentColor"
      />
      <path
        d="M8.01001 22.75C7.60001 22.75 7.26001 22.41 7.26001 22V20C7.26001 19.59 7.60001 19.25 8.01001 19.25C8.42001 19.25 8.76001 19.59 8.76001 20V22C8.76001 22.41 8.42001 22.75 8.01001 22.75Z"
        fill="currentColor"
      />
      <path
        d="M4 8.75H2C1.59 8.75 1.25 8.42 1.25 8C1.25 7.58 1.59 7.25 2 7.25H4C4.41 7.25 4.75 7.59 4.75 8C4.75 8.41 4.42 8.75 4 8.75Z"
        fill="currentColor"
      />
      <path
        d="M4 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H4C4.41 11.25 4.75 11.59 4.75 12C4.75 12.41 4.42 12.75 4 12.75Z"
        fill="currentColor"
      />
      <path
        d="M4 16.75H2C1.59 16.75 1.25 16.41 1.25 16C1.25 15.59 1.59 15.25 2 15.25H4C4.41 15.25 4.75 15.59 4.75 16C4.75 16.41 4.42 16.75 4 16.75Z"
        fill="currentColor"
      />
      <path
        d="M16.7101 19.3402C15.4201 19.3402 14.3701 18.2902 14.3701 17.0002C14.3701 15.7102 15.4201 14.6602 16.7101 14.6602C18.0001 14.6602 19.0501 15.7102 19.0501 17.0002C19.0401 18.2902 18.0001 19.3402 16.7101 19.3402ZM16.7101 16.1602C16.2501 16.1602 15.8701 16.5402 15.8701 17.0002C15.8701 17.4602 16.2501 17.8402 16.7101 17.8402C17.1701 17.8402 17.5501 17.4602 17.5501 17.0002C17.5401 16.5402 17.1701 16.1602 16.7101 16.1602Z"
        fill="currentColor"
      />
      <path
        d="M18.3999 22.7501C17.8399 22.7501 17.2899 22.4601 16.9899 21.9401L16.9199 21.8301C16.8099 21.6401 16.7199 21.5901 16.6999 21.5801C16.6899 21.5801 16.5899 21.6401 16.4799 21.8301L16.4199 21.9301C15.9599 22.7201 14.9499 22.9801 14.1799 22.5201L13.2799 22.0001C12.8699 21.7701 12.5799 21.3901 12.4599 20.9301C12.3399 20.4801 12.3999 20.0001 12.6299 19.6001C12.7399 19.4101 12.7399 19.3001 12.7299 19.2801C12.7199 19.2701 12.6299 19.2201 12.4099 19.2201C11.4399 19.2201 10.6499 18.4301 10.6499 17.4701V16.5401C10.6499 15.5701 11.4399 14.7901 12.3999 14.7901C12.6199 14.7901 12.7099 14.7301 12.7299 14.7201C12.7299 14.7101 12.7299 14.6001 12.6199 14.4101C12.3899 14.0001 12.3199 13.5301 12.4499 13.0801C12.5699 12.6301 12.8599 12.2501 13.2699 12.0101L14.1799 11.4801C14.9399 11.0301 15.9499 11.2901 16.3999 12.0701L16.4599 12.1801C16.5699 12.3701 16.6599 12.4201 16.6799 12.4301C16.6899 12.4301 16.7899 12.3701 16.8999 12.1801L16.9599 12.0801C17.4299 11.2901 18.4299 11.0301 19.1999 11.4901L20.1299 12.0001C20.5399 12.2301 20.8299 12.6101 20.9499 13.0701C21.0699 13.5201 21.0099 14.0001 20.7799 14.4001C20.6699 14.5901 20.6699 14.7001 20.6799 14.7201C20.6899 14.7301 20.7799 14.7801 20.9999 14.7801C21.9699 14.7801 22.7599 15.5701 22.7599 16.5301V17.4601C22.7599 18.4301 21.9699 19.2101 21.0099 19.2101C20.7899 19.2101 20.6999 19.2701 20.6799 19.2801C20.6799 19.2901 20.6799 19.4001 20.7899 19.5901C21.0199 20.0001 21.0899 20.4701 20.9599 20.9201C20.8399 21.3701 20.5499 21.7501 20.1399 21.9901L19.2299 22.5201C18.9599 22.6701 18.6799 22.7501 18.3999 22.7501ZM16.7099 20.0801C17.3099 20.0801 17.8599 20.4401 18.2299 21.0801L18.2899 21.1901C18.3199 21.2401 18.3999 21.2701 18.4599 21.2301L19.3799 20.7001C19.4599 20.6601 19.4899 20.5801 19.4999 20.5401C19.5099 20.5001 19.5199 20.4301 19.4799 20.3501C19.1099 19.7201 19.0799 19.0601 19.3799 18.5401C19.6799 18.0201 20.2699 17.7201 20.9999 17.7201C21.1399 17.7201 21.2599 17.6001 21.2599 17.4701V16.5401C21.2599 16.4001 21.1399 16.2901 21.0099 16.2901C20.2799 16.2901 19.6799 15.9901 19.3899 15.4701C19.0899 14.9501 19.1299 14.2901 19.4899 13.6601C19.5399 13.5801 19.5299 13.5001 19.5099 13.4701C19.4999 13.4301 19.4699 13.3601 19.3899 13.3101L18.4799 12.7801C18.4099 12.7401 18.3299 12.7701 18.2899 12.8301L18.2399 12.9201C17.8699 13.5601 17.3199 13.9201 16.7199 13.9201C16.1199 13.9201 15.5699 13.5601 15.1999 12.9201L15.1399 12.8201C15.1099 12.7601 15.0199 12.7401 14.9699 12.7701L14.0499 13.3001C13.9699 13.3401 13.9399 13.4201 13.9299 13.4601C13.9199 13.5001 13.9099 13.5701 13.9499 13.6501C14.3199 14.2801 14.3499 14.9401 14.0499 15.4601C13.7499 15.9801 13.1599 16.2801 12.4299 16.2801C12.2899 16.2801 12.1699 16.4001 12.1699 16.5301V17.4601C12.1699 17.6001 12.2899 17.7101 12.4199 17.7101C13.1499 17.7101 13.7499 18.0101 14.0399 18.5301C14.3399 19.0501 14.2999 19.7101 13.9399 20.3401C13.8999 20.4201 13.9099 20.4901 13.9199 20.5301C13.9299 20.5701 13.9599 20.6401 14.0399 20.6901L14.9499 21.2201C15.0199 21.2601 15.0999 21.2301 15.1399 21.1701L15.1899 21.0701C15.5499 20.4401 16.1099 20.0801 16.7099 20.0801Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CurveBottomIcon = ({ width, height }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1441 266"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.19043 266H1440.19L0.191044 0.100174L0.19043 266Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
export const CallingIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4545 3.125C13.514 3.40995 14.48 3.9683 15.2559 4.74412C16.0317 5.51994 16.59 6.48599 16.875 7.54552"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8073 5.54053C12.443 5.7115 13.0226 6.04651 13.4881 6.512C13.9536 6.97749 14.2886 7.55712 14.4596 8.19284"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.22471 9.75109C7.87302 11.0765 8.94739 12.146 10.2758 12.7883C10.3729 12.8343 10.4804 12.8543 10.5877 12.8462C10.6949 12.838 10.7982 12.8021 10.8874 12.742L12.8433 11.4377C12.9298 11.3801 13.0293 11.3449 13.1328 11.3354C13.2364 11.3259 13.3407 11.3423 13.4362 11.3833L17.0954 12.9515C17.2197 13.0043 17.3234 13.096 17.3911 13.213C17.4587 13.3299 17.4865 13.4656 17.4702 13.5997C17.3546 14.5047 16.913 15.3365 16.2282 15.9394C15.5434 16.5422 14.6624 16.8748 13.75 16.8749C10.9321 16.8749 8.22956 15.7555 6.23699 13.7629C4.24442 11.7703 3.125 9.06782 3.125 6.24989C3.12505 5.33753 3.45765 4.45647 4.06053 3.77167C4.66341 3.08688 5.49523 2.64531 6.40023 2.52966C6.53431 2.51343 6.67002 2.54122 6.78693 2.60883C6.90384 2.67644 6.99561 2.78022 7.04841 2.90452L8.61798 6.56685C8.65858 6.66158 8.67512 6.76488 8.66614 6.86755C8.65715 6.97022 8.62291 7.06908 8.56647 7.15531L7.26676 9.14123C7.2076 9.23056 7.17263 9.33372 7.16526 9.44061C7.15789 9.5475 7.17837 9.65448 7.22471 9.75109V9.75109Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LogoXIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.915 0.847168H13.0026L8.44175 6.06011L13.8074 13.1535H9.606L6.31556 8.85129L2.55044 13.1535H0.461502L5.33975 7.57779L0.192627 0.847168H4.50038L7.47475 4.77948L10.915 0.847168ZM10.1823 11.9039H11.3391L3.87188 2.03117H2.63063L10.1823 11.9039Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LinkedInIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.85351 13.3812H4.82485V4.35183H7.85295V5.61424L7.97427 5.47203C8.49092 4.85261 9.1859 4.40746 9.9646 4.1972C10.1289 4.16831 10.2955 4.15378 10.4623 4.15375H10.5949C10.8982 4.15366 11.2007 4.18429 11.4978 4.24517C12.925 4.62102 13.7799 5.7384 13.969 7.47599C13.9887 7.65319 14 8.78073 14 10.5697V13.3801H10.9713L10.9623 10.6487L10.9538 7.91899L10.8856 7.69043C10.8383 7.36849 10.6764 7.07444 10.4296 6.86231C10.1829 6.65019 9.86788 6.53425 9.5425 6.5358H9.47139C9.16748 6.53623 8.87013 6.6243 8.615 6.78946C8.35987 6.95461 8.15779 7.18984 8.03296 7.46696C7.85408 7.82982 7.85408 7.82982 7.85408 10.7497V13.3778L7.85351 13.3812ZM3.19116 13.3812H0.160245V4.35465H3.18947V13.384L3.19116 13.3812ZM1.74032 3.1481H1.69461C1.53913 3.14746 1.3841 3.1312 1.23187 3.09957C0.889963 3.02689 0.582506 2.84114 0.359101 2.57229C0.135695 2.30344 0.00936884 1.96716 0.000500878 1.61771C-0.00836709 1.26826 0.10074 0.926012 0.310222 0.646175C0.519704 0.366338 0.817343 0.165232 1.15513 0.0753003C1.33926 0.0263131 1.5289 0.00108972 1.71944 0.000244141H1.80409C2.0106 0.000317069 2.21508 0.0411519 2.40578 0.120408C2.59649 0.199665 2.76968 0.315784 2.91542 0.462108C3.06116 0.608433 3.17659 0.782085 3.25509 0.97311C3.33359 1.16414 3.37362 1.36878 3.37287 1.5753C3.37744 1.77707 3.34144 1.9777 3.26699 2.16528C3.19254 2.35286 3.08117 2.52357 2.93948 2.66729C2.61697 2.97659 2.18717 3.14892 1.74032 3.1481Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const InstagramIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1349 14.0002H3.8622C2.83858 13.9973 1.85775 13.5893 1.13405 12.8653C0.410357 12.1414 0.00263835 11.1604 0 10.1367V3.86377C0.00279279 2.84016 0.410561 1.85926 1.13423 1.13535C1.85789 0.411433 2.83863 0.00334878 3.8622 0.000244141H10.1349C11.1585 0.00334878 12.1392 0.411433 12.8629 1.13535C13.5865 1.85926 13.9943 2.84016 13.9971 3.86377V10.1367C13.9946 11.1604 13.5869 12.1415 12.8632 12.8655C12.1395 13.5895 11.1585 13.9974 10.1349 14.0002ZM3.8622 1.2426C3.1682 1.24615 2.50364 1.52347 2.01296 2.01429C1.52227 2.5051 1.24512 3.16974 1.24171 3.86377V10.1367C1.24527 10.8308 1.52246 11.4954 2.01309 11.9862C2.50373 12.4771 3.16819 12.7546 3.8622 12.7585H10.1349C10.829 12.7548 11.4936 12.4773 11.9844 11.9864C12.4751 11.4956 12.7524 10.8309 12.756 10.1367V3.86377C12.7524 3.16969 12.4751 2.50505 11.9843 2.01425C11.4936 1.52345 10.8289 1.24615 10.1349 1.2426H3.8622ZM6.99795 10.6079C6.28446 10.6079 5.58698 10.3963 4.99373 9.99989C4.40048 9.60348 3.9381 9.04004 3.66506 8.38083C3.39201 7.72162 3.32057 6.99624 3.45977 6.29643C3.59897 5.59661 3.94255 4.95379 4.44706 4.44925C4.95158 3.94471 5.59438 3.60112 6.29417 3.46192C6.99395 3.32272 7.7193 3.39416 8.37849 3.66721C9.03767 3.94027 9.60108 4.40267 9.99748 4.99594C10.3939 5.58922 10.6055 6.28672 10.6055 7.00024C10.6055 7.95705 10.2254 8.87467 9.54884 9.55124C8.87231 10.2278 7.95472 10.6079 6.99795 10.6079ZM6.99795 4.63436C6.37066 4.63436 5.76907 4.88356 5.32551 5.32714C4.88195 5.77072 4.63275 6.37234 4.63275 6.99966C4.63275 7.62697 4.88195 8.22859 5.32551 8.67217C5.76907 9.11575 6.37066 9.36495 6.99795 9.36495H7.01384C7.3221 9.36575 7.62746 9.30544 7.91227 9.18751C8.19709 9.06958 8.4557 8.89637 8.67318 8.67789C9.00374 8.34657 9.22877 7.92478 9.3199 7.46571C9.41102 7.00665 9.36416 6.53087 9.18522 6.09841C9.00628 5.66595 8.70327 5.29617 8.31442 5.03572C7.92558 4.77527 7.46831 4.63582 7.00031 4.63495L6.99795 4.63436ZM10.7572 4.15966C10.5543 4.15972 10.3571 4.09197 10.1971 3.96718C10.037 3.84239 9.92325 3.66771 9.87381 3.47087C9.82438 3.27403 9.84212 3.06631 9.92422 2.88071C10.0063 2.6951 10.1481 2.54224 10.327 2.4464C10.5059 2.35056 10.7116 2.31724 10.9116 2.35172C11.1116 2.38619 11.2944 2.4865 11.4309 2.63671C11.5673 2.78692 11.6497 2.97842 11.6649 3.1808C11.6801 3.38318 11.6273 3.58485 11.5148 3.75377C11.4317 3.87858 11.3191 3.98093 11.1869 4.05173C11.0548 4.12254 10.9072 4.15961 10.7572 4.15966Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FacebookIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 16 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2667 15.8895L15.1645 11.0003H9.93822V9.27139C9.93822 6.6875 10.9523 5.69355 13.5758 5.69355C14.3906 5.69355 15.0463 5.71367 15.4241 5.75327V1.32105C14.7087 1.12239 12.9597 0.923096 11.9456 0.923096C6.59928 0.923096 4.13484 3.44789 4.13484 8.89355V11.0003H0.83551V15.8895H4.13484V26.5294C5.37272 26.8362 6.66718 27.0003 7.99999 27.0003C8.65634 27.0003 9.30262 26.96 9.93822 26.8833V15.8895H14.2667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const QuestionIcon = ({ width, height }) => {
  return (
    <svg
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.031 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.7411 9.25718 8.87418C9.23529 9.00726 9.24055 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52854 9.44389 9.63643C9.52481 9.74433 9.62671 9.83475 9.74348 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.3474 11.345 9.22078 11.4978 9.13298C11.6505 9.04518 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71352C13.3828 7.25801 12.7035 7.00546 12 7Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const NotValidIcon = ({ width, height }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      width={width || fallbackWidth}
      height={height || fallbackHeight}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke-width="2"
        d="M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M9,12 L15,18 M15,12 L9,18"
      ></path>
    </svg>
  );
};
